var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndergraduateVisual({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 475,
    height: 335,
    viewBox: "0 0 475 335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19438",
    "data-name": "Rectangle 19438",
    width: 475,
    height: 335,
    transform: "translate(1032 326)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18543",
    "data-name": "Rectangle 18543",
    width: 474.08,
    height: 307.398,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18490",
    "data-name": "Rectangle 18490",
    width: 110.638,
    height: 76.95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18531",
    "data-name": "Rectangle 18531",
    width: 117.616,
    height: 27.966,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18535",
    "data-name": "Rectangle 18535",
    width: 18.44,
    height: 49.796,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18536",
    "data-name": "Rectangle 18536",
    width: 1.679,
    height: 1.698,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18539",
    "data-name": "Rectangle 18539",
    width: 1.759,
    height: 1.776,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18541",
    "data-name": "Rectangle 18541",
    width: 1.577,
    height: 1.595,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_148",
    "data-name": "Mask Group 148",
    transform: "translate(-1032 -326)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44381",
    "data-name": "Group 44381",
    transform: "translate(1033 340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44380",
    "data-name": "Group 44380",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44349",
    "data-name": "Group 44349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44348",
    "data-name": "Group 44348",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90716",
    "data-name": "Path 90716",
    d: "M268.637,303.5a8.11,8.11,0,0,1,4.154,6.553,12.206,12.206,0,0,0-4.154-6.553",
    transform: "translate(-92.75 -104.785)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90717",
    "data-name": "Path 90717",
    d: "M278.218,297.234c.108.022-.379,2.347-.441,5.256-.079,2.91.3,5.256.188,5.272a5.6,5.6,0,0,1-.332-1.524,23.52,23.52,0,0,1,.18-7.5,5.63,5.63,0,0,1,.4-1.506",
    transform: "translate(-95.782 -102.625)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90718",
    "data-name": "Path 90718",
    d: "M286.888,300.931a22.682,22.682,0,0,0-3.614,8.252,4.007,4.007,0,0,1,.113-1.342,14.241,14.241,0,0,1,2.591-5.917,4.019,4.019,0,0,1,.91-.993",
    transform: "translate(-97.797 -103.901)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90719",
    "data-name": "Path 90719",
    d: "M119.793,409.562a8.109,8.109,0,0,1,4.154,6.553,12.2,12.2,0,0,0-4.154-6.553",
    transform: "translate(-41.36 -141.406)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90720",
    "data-name": "Path 90720",
    d: "M129.374,403.3c.108.022-.379,2.347-.441,5.256-.079,2.91.3,5.256.188,5.272a5.6,5.6,0,0,1-.332-1.524,23.57,23.57,0,0,1,.18-7.5,5.628,5.628,0,0,1,.4-1.506",
    transform: "translate(-44.392 -139.246)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90721",
    "data-name": "Path 90721",
    d: "M138.044,407a22.682,22.682,0,0,0-3.614,8.252,4.008,4.008,0,0,1,.113-1.342,14.248,14.248,0,0,1,2.591-5.918,4.008,4.008,0,0,1,.91-.993",
    transform: "translate(-46.406 -140.522)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90722",
    "data-name": "Path 90722",
    d: "M425.42,356.666a8.109,8.109,0,0,1,4.154,6.553,12.206,12.206,0,0,0-4.154-6.553",
    transform: "translate(-146.882 -123.143)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90723",
    "data-name": "Path 90723",
    d: "M435,350.406c.108.022-.379,2.347-.441,5.256-.079,2.91.3,5.256.188,5.272a5.6,5.6,0,0,1-.332-1.524,23.52,23.52,0,0,1,.18-7.5,5.629,5.629,0,0,1,.4-1.506",
    transform: "translate(-149.914 -120.983)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90724",
    "data-name": "Path 90724",
    d: "M443.671,354.1a22.682,22.682,0,0,0-3.614,8.252,4.008,4.008,0,0,1,.113-1.342,14.241,14.241,0,0,1,2.591-5.917,4.019,4.019,0,0,1,.91-.993",
    transform: "translate(-151.929 -122.259)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90725",
    "data-name": "Path 90725",
    d: "M671.582,326.9a8.109,8.109,0,0,1,4.154,6.553,12.2,12.2,0,0,0-4.154-6.553",
    transform: "translate(-231.873 -112.866)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90726",
    "data-name": "Path 90726",
    d: "M681.163,320.641c.108.022-.379,2.347-.441,5.256-.079,2.91.3,5.256.188,5.272a5.6,5.6,0,0,1-.332-1.524,23.567,23.567,0,0,1,.18-7.5,5.627,5.627,0,0,1,.4-1.506",
    transform: "translate(-234.906 -110.706)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90727",
    "data-name": "Path 90727",
    d: "M689.834,324.337a22.683,22.683,0,0,0-3.614,8.252,4.008,4.008,0,0,1,.113-1.342,14.248,14.248,0,0,1,2.591-5.918,4.006,4.006,0,0,1,.91-.993",
    transform: "translate(-236.921 -111.982)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90728",
    "data-name": "Path 90728",
    d: "M596.419,406.547a8.11,8.11,0,0,1,4.154,6.553,12.2,12.2,0,0,0-4.154-6.553",
    transform: "translate(-205.922 -140.365)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90729",
    "data-name": "Path 90729",
    d: "M606,400.286c.108.022-.379,2.347-.441,5.256-.079,2.91.3,5.256.188,5.272a5.6,5.6,0,0,1-.332-1.524,23.521,23.521,0,0,1,.18-7.5,5.626,5.626,0,0,1,.4-1.506",
    transform: "translate(-208.955 -138.205)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90730",
    "data-name": "Path 90730",
    d: "M614.671,403.983a22.683,22.683,0,0,0-3.614,8.252,4.007,4.007,0,0,1,.113-1.342,14.24,14.24,0,0,1,2.591-5.917,4.021,4.021,0,0,1,.91-.993",
    transform: "translate(-210.969 -139.481)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90731",
    "data-name": "Path 90731",
    d: "M95,246.305a8.109,8.109,0,0,1,4.154,6.553A12.2,12.2,0,0,0,95,246.305",
    transform: "translate(-32.801 -85.039)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90732",
    "data-name": "Path 90732",
    d: "M104.585,240.044c.108.022-.379,2.347-.441,5.256-.079,2.91.3,5.256.188,5.272a5.6,5.6,0,0,1-.332-1.524,23.57,23.57,0,0,1,.18-7.5,5.629,5.629,0,0,1,.4-1.506",
    transform: "translate(-35.833 -82.879)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90733",
    "data-name": "Path 90733",
    d: "M113.256,243.741a38.169,38.169,0,0,0-2.221,3.945,38.2,38.2,0,0,0-1.393,4.307,4.007,4.007,0,0,1,.113-1.342,14.241,14.241,0,0,1,2.591-5.917,4.019,4.019,0,0,1,.91-.993",
    transform: "translate(-37.848 -84.155)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90734",
    "data-name": "Path 90734",
    d: "M35.661,378.169a8.109,8.109,0,0,1,4.154,6.553,16.9,16.9,0,0,0-1.543-3.615,16.924,16.924,0,0,0-2.612-2.938",
    transform: "translate(-12.312 -130.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90735",
    "data-name": "Path 90735",
    d: "M45.243,371.909c.108.022-.379,2.347-.441,5.256-.079,2.91.3,5.256.188,5.272a5.6,5.6,0,0,1-.332-1.524,23.57,23.57,0,0,1,.18-7.5,5.629,5.629,0,0,1,.4-1.506",
    transform: "translate(-15.344 -128.407)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90736",
    "data-name": "Path 90736",
    d: "M53.913,375.606a38.178,38.178,0,0,0-2.221,3.945,38.2,38.2,0,0,0-1.393,4.307,4.007,4.007,0,0,1,.113-1.342A14.241,14.241,0,0,1,53,376.6a4.02,4.02,0,0,1,.91-.993",
    transform: "translate(-17.359 -129.683)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90737",
    "data-name": "Path 90737",
    d: "M603.317,245.033a8.109,8.109,0,0,1,4.154,6.553,12.2,12.2,0,0,0-4.154-6.553",
    transform: "translate(-208.304 -84.6)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90738",
    "data-name": "Path 90738",
    d: "M612.9,238.773c.108.022-.379,2.347-.441,5.256-.079,2.91.3,5.256.188,5.272a5.6,5.6,0,0,1-.332-1.524,23.52,23.52,0,0,1,.18-7.5,5.633,5.633,0,0,1,.4-1.506",
    transform: "translate(-211.336 -82.44)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90739",
    "data-name": "Path 90739",
    d: "M621.569,242.47a37.951,37.951,0,0,0-2.221,3.945,38.179,38.179,0,0,0-1.393,4.307,4.029,4.029,0,0,1,.113-1.342,14.271,14.271,0,0,1,2.591-5.918,3.987,3.987,0,0,1,.911-.993",
    transform: "translate(-213.351 -83.716)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18455",
    "data-name": "Rectangle 18455",
    width: 4.516,
    height: 15.526,
    transform: "translate(427.445 118.017)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90740",
    "data-name": "Path 90740",
    d: "M664.644,158.079s-.222-.148.267-.788a.621.621,0,0,0-.267-.986c-2.134,1.232-5.114,0-5.114,0s3.513-1.084,3.957-2.119c.332-.773-.253-.858-.571-.852.358-.037,1.135-.164,1.371-.577.312-.542-.911-1.183-.911-1.183a.954.954,0,0,0,0-.837c-.2-.542-4.781-1.331-4.781-1.331a1.816,1.816,0,0,0,1.823-1.183s2.268.05,2.8-.837-.356-1.134-1.868-1.873a39.975,39.975,0,0,1-4.847-3.5,7.431,7.431,0,0,0,2.668-.69c.578-.493.044-.592.044-.592,2.49.247,1.645-1.084,1.645-1.084a11.139,11.139,0,0,1-5.114-3.3,6.128,6.128,0,0,0,2.357-1.085c.8-.739-.667-.936-.667-.936s2.935-.394,1.245-1.478c-1.285-.824-3.339-1.933-3.978-2.266a6.129,6.129,0,0,0,2.288-.05c1.868-.838,0-2.07,0-2.07a36.3,36.3,0,0,1-5.381-4.337s1.6.837,2.4.591-.89-1.232-.89-1.232.845.246,1.2,0-.934-1.38-.934-1.38c-1.917-1.245-4.28-4.514-5.269-5.919-.989,1.4-3.352,4.673-5.269,5.919,0,0-1.289,1.134-.934,1.38s1.2,0,1.2,0-1.69.986-.89,1.232,2.4-.591,2.4-.591a36.3,36.3,0,0,1-5.381,4.337s-1.868,1.232,0,2.07a6.126,6.126,0,0,0,2.288.05c-.638.333-2.693,1.442-3.978,2.266-1.69,1.084,1.245,1.478,1.245,1.478s-1.467.2-.667.936a6.128,6.128,0,0,0,2.357,1.085,11.139,11.139,0,0,1-5.114,3.3s-.845,1.331,1.645,1.084c0,0-.534.1.045.592a7.427,7.427,0,0,0,2.668.69,39.978,39.978,0,0,1-4.847,3.5c-1.512.739-2.4.986-1.868,1.873s2.8.837,2.8.837a1.815,1.815,0,0,0,1.823,1.183s-4.58.789-4.78,1.331a.954.954,0,0,0,0,.837s-1.222.641-.911,1.183c.237.412,1.013.54,1.372.577-.318-.006-.9.079-.571.852.445,1.035,3.958,2.119,3.958,2.119s-2.98,1.232-5.114,0a.621.621,0,0,0-.267.986c.49.64.267.788.267.788s-1.112-.838-.623.443,3.068,2.07,3.068,2.07-1.467.247-1.023,1.035,2.313,1.725,4.358,1.922a16.623,16.623,0,0,0,4.8-.542s-1.867.985-.578,1.527,2.757-.69,2.757-.69-.266,1.262.8.828a7.272,7.272,0,0,0,1.956-1.271s.333,1.859,1,1.414c.667.445,1-1.414,1-1.414a7.271,7.271,0,0,0,1.956,1.271c1.067.433.8-.828.8-.828s1.467,1.232,2.757.69-.578-1.527-.578-1.527a16.623,16.623,0,0,0,4.8.542c2.045-.2,3.913-1.134,4.358-1.922s-1.023-1.035-1.023-1.035,2.579-.788,3.068-2.07-.623-.443-.623-.443",
    transform: "translate(-217.814 -40.113)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90741",
    "data-name": "Path 90741",
    d: "M667.117,135.143l-.07-.032a.243.243,0,0,1,.07.032",
    transform: "translate(-230.308 -46.649)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18456",
    "data-name": "Rectangle 18456",
    width: 4.516,
    height: 15.526,
    transform: "translate(37.785 118.017)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90742",
    "data-name": "Path 90742",
    d: "M69.5,158.079s-.222-.148.267-.788a.621.621,0,0,0-.267-.986c-2.134,1.232-5.114,0-5.114,0s3.513-1.084,3.958-2.119c.332-.773-.253-.858-.571-.852.358-.037,1.135-.164,1.372-.577.311-.542-.911-1.183-.911-1.183a.954.954,0,0,0,0-.837c-.2-.542-4.781-1.331-4.781-1.331a1.816,1.816,0,0,0,1.823-1.183s2.268.05,2.8-.837-.356-1.134-1.868-1.873a39.975,39.975,0,0,1-4.847-3.5,7.431,7.431,0,0,0,2.668-.69c.578-.493.045-.592.045-.592,2.49.247,1.645-1.084,1.645-1.084a11.139,11.139,0,0,1-5.114-3.3,6.128,6.128,0,0,0,2.357-1.085c.8-.739-.667-.936-.667-.936s2.935-.394,1.245-1.478c-1.285-.824-3.339-1.933-3.978-2.266a6.129,6.129,0,0,0,2.288-.05c1.868-.838,0-2.07,0-2.07a36.3,36.3,0,0,1-5.381-4.337s1.6.837,2.4.591-.89-1.232-.89-1.232.845.246,1.2,0-.934-1.38-.934-1.38c-1.917-1.245-4.28-4.514-5.269-5.919-.989,1.4-3.352,4.673-5.269,5.919,0,0-1.289,1.134-.934,1.38s1.2,0,1.2,0-1.69.986-.89,1.232,2.4-.591,2.4-.591a36.3,36.3,0,0,1-5.381,4.337s-1.868,1.232,0,2.07a6.126,6.126,0,0,0,2.288.05c-.638.333-2.693,1.442-3.978,2.266-1.69,1.084,1.245,1.478,1.245,1.478s-1.468.2-.667.936a6.128,6.128,0,0,0,2.357,1.085,11.139,11.139,0,0,1-5.114,3.3s-.845,1.331,1.645,1.084c0,0-.534.1.045.592a7.431,7.431,0,0,0,2.668.69,39.975,39.975,0,0,1-4.847,3.5c-1.512.739-2.4.986-1.868,1.873s2.8.837,2.8.837a1.816,1.816,0,0,0,1.823,1.183s-4.581.789-4.781,1.331a.954.954,0,0,0,0,.837s-1.222.641-.911,1.183c.237.412,1.014.54,1.372.577-.318-.006-.9.079-.571.852.445,1.035,3.958,2.119,3.958,2.119s-2.98,1.232-5.114,0a.621.621,0,0,0-.267.986c.49.64.267.788.267.788s-1.112-.838-.623.443,3.068,2.07,3.068,2.07-1.467.247-1.023,1.035,2.313,1.725,4.358,1.922a16.623,16.623,0,0,0,4.8-.542s-1.867.985-.578,1.527,2.757-.69,2.757-.69-.266,1.262.8.828a7.272,7.272,0,0,0,1.956-1.271s.333,1.859,1,1.414c.667.445,1-1.414,1-1.414a7.272,7.272,0,0,0,1.956,1.271c1.067.433.8-.828.8-.828s1.467,1.232,2.757.69-.578-1.527-.578-1.527a16.623,16.623,0,0,0,4.8.542c2.045-.2,3.913-1.134,4.358-1.922s-1.023-1.035-1.023-1.035,2.579-.788,3.068-2.07-.623-.443-.623-.443",
    transform: "translate(-12.332 -40.113)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90743",
    "data-name": "Path 90743",
    d: "M71.976,135.143l-.069-.032a.248.248,0,0,1,.069.032",
    transform: "translate(-24.827 -46.649)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18457",
    "data-name": "Rectangle 18457",
    width: 5.509,
    height: 18.938,
    transform: "translate(449.525 114.605)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90744",
    "data-name": "Path 90744",
    d: "M700.959,148s-.271-.18.325-.962a.757.757,0,0,0-.325-1.2c-2.6,1.5-6.238,0-6.238,0s4.285-1.323,4.827-2.585c.405-.943-.309-1.048-.7-1.04.437-.045,1.384-.2,1.673-.7.38-.661-1.112-1.443-1.112-1.443a1.163,1.163,0,0,0,0-1.022c-.244-.661-5.83-1.623-5.83-1.623a2.214,2.214,0,0,0,2.224-1.442s2.766.06,3.417-1.022-.434-1.383-2.278-2.284a48.786,48.786,0,0,1-5.912-4.268s2.549-.241,3.254-.842.054-.722.054-.722c3.037.3,2.007-1.323,2.007-1.323a13.58,13.58,0,0,1-6.237-4.027,7.489,7.489,0,0,0,2.875-1.323c.976-.9-.814-1.143-.814-1.143s3.579-.481,1.518-1.8c-1.567-1.006-4.073-2.358-4.852-2.764a7.463,7.463,0,0,0,2.79-.062c2.279-1.022,0-2.525,0-2.525a44.244,44.244,0,0,1-6.562-5.29s1.952,1.022,2.929.722-1.085-1.5-1.085-1.5,1.031.3,1.465,0-1.139-1.683-1.139-1.683c-2.338-1.52-5.22-5.507-6.426-7.219-1.205,1.712-4.088,5.7-6.426,7.219,0,0-1.573,1.382-1.139,1.683s1.465,0,1.465,0-2.061,1.2-1.085,1.5,2.929-.722,2.929-.722a44.242,44.242,0,0,1-6.562,5.29s-2.278,1.5,0,2.525a7.464,7.464,0,0,0,2.791.062c-.779.407-3.285,1.759-4.852,2.764-2.061,1.323,1.518,1.8,1.518,1.8s-1.79.241-.813,1.143a7.483,7.483,0,0,0,2.874,1.323,13.58,13.58,0,0,1-6.238,4.027s-1.031,1.623,2.007,1.323c0,0-.651.12.054.722s3.255.842,3.255.842a48.786,48.786,0,0,1-5.912,4.268c-1.844.9-2.929,1.2-2.278,2.284s3.417,1.022,3.417,1.022a2.214,2.214,0,0,0,2.223,1.442s-5.587.962-5.83,1.623a1.163,1.163,0,0,0,0,1.022s-1.492.782-1.112,1.443c.289.5,1.235.658,1.673.7-.388-.007-1.1.1-.7,1.04.542,1.262,4.827,2.585,4.827,2.585s-3.634,1.5-6.238,0a.757.757,0,0,0-.325,1.2c.6.782.325.962.325.962s-1.356-1.022-.759.541,3.742,2.525,3.742,2.525-1.789.3-1.247,1.262,2.821,2.1,5.315,2.345a20.278,20.278,0,0,0,5.858-.661s-2.278,1.2-.705,1.863,3.363-.841,3.363-.841-.325,1.538.976,1.01a8.871,8.871,0,0,0,2.386-1.551s.407,2.267,1.219,1.725c.813.542,1.22-1.725,1.22-1.725a8.871,8.871,0,0,0,2.386,1.551c1.3.528.976-1.01.976-1.01s1.79,1.5,3.363.841-.705-1.863-.705-1.863a20.278,20.278,0,0,0,5.858.661c2.495-.24,4.773-1.383,5.315-2.345s-1.247-1.262-1.247-1.262,3.145-.962,3.742-2.525-.759-.541-.759-.541",
    transform: "translate(-227.789 -33.454)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90745",
    "data-name": "Path 90745",
    d: "M703.975,120.022l-.085-.039a.306.306,0,0,1,.085.039",
    transform: "translate(-243.029 -41.426)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18458",
    "data-name": "Rectangle 18458",
    width: 5.509,
    height: 18.938,
    transform: "translate(17.563 114.605)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90746",
    "data-name": "Path 90746",
    d: "M41.208,148s-.271-.18.325-.962a.757.757,0,0,0-.325-1.2c-2.6,1.5-6.238,0-6.238,0s4.285-1.323,4.827-2.585c.405-.943-.309-1.048-.7-1.04.437-.045,1.384-.2,1.673-.7.38-.661-1.112-1.443-1.112-1.443a1.163,1.163,0,0,0,0-1.022c-.244-.661-5.83-1.623-5.83-1.623a2.214,2.214,0,0,0,2.223-1.442s2.766.06,3.417-1.022-.434-1.383-2.278-2.284a48.788,48.788,0,0,1-5.912-4.268s2.55-.241,3.255-.842.054-.722.054-.722c3.037.3,2.007-1.323,2.007-1.323a13.584,13.584,0,0,1-6.238-4.027,7.489,7.489,0,0,0,2.875-1.323c.976-.9-.814-1.143-.814-1.143s3.579-.481,1.518-1.8c-1.566-1.006-4.072-2.358-4.852-2.764a7.463,7.463,0,0,0,2.79-.062c2.278-1.022,0-2.525,0-2.525a44.243,44.243,0,0,1-6.562-5.29s1.952,1.022,2.929.722-1.085-1.5-1.085-1.5,1.031.3,1.465,0-1.139-1.683-1.139-1.683c-2.338-1.52-5.22-5.507-6.426-7.219-1.205,1.712-4.088,5.7-6.426,7.219,0,0-1.573,1.382-1.139,1.683s1.465,0,1.465,0-2.061,1.2-1.085,1.5,2.929-.722,2.929-.722a44.243,44.243,0,0,1-6.562,5.29s-2.278,1.5,0,2.525a7.463,7.463,0,0,0,2.79.062c-.779.407-3.285,1.759-4.852,2.764-2.061,1.323,1.518,1.8,1.518,1.8s-1.79.241-.813,1.143a7.483,7.483,0,0,0,2.874,1.323,13.58,13.58,0,0,1-6.238,4.027s-1.031,1.623,2.007,1.323c0,0-.651.12.054.722s3.255.842,3.255.842a48.787,48.787,0,0,1-5.912,4.268c-1.844.9-2.929,1.2-2.278,2.284s3.417,1.022,3.417,1.022a2.214,2.214,0,0,0,2.223,1.442s-5.587.962-5.83,1.623a1.163,1.163,0,0,0,0,1.022s-1.491.782-1.112,1.443c.289.5,1.235.658,1.673.7-.388-.007-1.1.1-.7,1.04.542,1.262,4.827,2.585,4.827,2.585s-3.634,1.5-6.238,0a.757.757,0,0,0-.325,1.2c.6.782.325.962.325.962s-1.356-1.022-.759.541,3.742,2.525,3.742,2.525-1.789.3-1.247,1.262,2.821,2.1,5.315,2.345a20.278,20.278,0,0,0,5.858-.661s-2.278,1.2-.705,1.863,3.363-.841,3.363-.841-.325,1.538.976,1.01a8.871,8.871,0,0,0,2.387-1.551s.407,2.267,1.219,1.725c.813.542,1.22-1.725,1.22-1.725a8.884,8.884,0,0,0,2.387,1.551c1.3.528.976-1.01.976-1.01s1.79,1.5,3.363.841-.705-1.863-.705-1.863a20.278,20.278,0,0,0,5.858.661c2.495-.24,4.773-1.383,5.315-2.345s-1.247-1.262-1.247-1.262,3.145-.962,3.742-2.525-.759-.541-.759-.541",
    transform: "translate(0 -33.454)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90747",
    "data-name": "Path 90747",
    d: "M44.225,120.022l-.085-.039a.305.305,0,0,1,.085.039",
    transform: "translate(-15.24 -41.426)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90748",
    "data-name": "Path 90748",
    d: "M211.974,41.312a17.522,17.522,0,0,0-2.062-4.278,5.9,5.9,0,0,0-3.883-2.526,3.607,3.607,0,0,0-3.837,2.161c-.227-3.387-.706-6.862-2.4-9.8s-4.859-5.25-8.247-5.043c-3.2.2-5.93,2.569-7.45,5.385s-2.042,6.048-2.541,9.209c-1.211-1.486-3.768-1.019-5.032.422s-1.584,3.456-1.853,5.354h38.118Z",
    transform: "translate(-60.307 -7.53)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90749",
    "data-name": "Path 90749",
    d: "M525.42,44.493a17.522,17.522,0,0,0-2.062-4.278,5.9,5.9,0,0,0-3.883-2.526,3.607,3.607,0,0,0-3.837,2.161c-.227-3.387-.706-6.862-2.4-9.8S508.377,24.8,504.989,25c-3.2.2-5.93,2.569-7.45,5.385S495.5,36.436,495,39.6c-1.211-1.486-3.768-1.019-5.032.423s-1.584,3.456-1.853,5.354h38.118Z",
    transform: "translate(-168.529 -8.628)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90750",
    "data-name": "Path 90750",
    d: "M261.867,20.5a8.4,8.4,0,0,0-.993-2.058,2.838,2.838,0,0,0-1.868-1.216,1.736,1.736,0,0,0-1.846,1.04A10.791,10.791,0,0,0,256,13.553a4.522,4.522,0,0,0-3.968-2.426,4.643,4.643,0,0,0-3.583,2.591,13.689,13.689,0,0,0-1.222,4.431,1.665,1.665,0,0,0-2.421.2,4.824,4.824,0,0,0-.891,2.575h18.338Z",
    transform: "translate(-84.217 -3.84)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90751",
    "data-name": "Path 90751",
    d: "M694.623,56.259a8.442,8.442,0,0,0-.993-2.058,2.838,2.838,0,0,0-1.867-1.215,1.737,1.737,0,0,0-1.846,1.04,10.79,10.79,0,0,0-1.155-4.716,4.523,4.523,0,0,0-3.968-2.426,4.643,4.643,0,0,0-3.584,2.591,13.706,13.706,0,0,0-1.222,4.431,1.665,1.665,0,0,0-2.421.2,4.824,4.824,0,0,0-.891,2.575h18.339Z",
    transform: "translate(-233.633 -16.185)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44351",
    "data-name": "Group 44351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44350",
    "data-name": "Group 44350",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90752",
    "data-name": "Path 90752",
    d: "M465.883,203.876c0,.094-102.046.17-227.9.17-125.895,0-227.919-.076-227.919-.17s102.024-.17,227.919-.17c125.851,0,227.9.076,227.9.17",
    transform: "translate(-3.476 -70.333)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44353",
    "data-name": "Group 44353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44352",
    "data-name": "Group 44352",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90753",
    "data-name": "Path 90753",
    d: "M87.25,292.425a4.584,4.584,0,0,1,2.756,2.3,8.09,8.09,0,0,1,.866,3.555,14.275,14.275,0,0,1-2.015,7.029c-2.233-1.416-3.145-4.343-3.516-5.857-.585-2.393-.189-7.073,1.909-7.025",
    transform: "translate(-29.381 -100.964)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90754",
    "data-name": "Path 90754",
    d: "M95.109,314.48a3.908,3.908,0,0,1,.684-3.866,5.187,5.187,0,0,1,3.6-1.764,2.187,2.187,0,0,1,1.776.49,1.673,1.673,0,0,1,.284,1.671,3.406,3.406,0,0,1-1.053,1.412c-1.541,1.332-3.278,2.339-5.294,2.056",
    transform: "translate(-32.753 -106.631)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90755",
    "data-name": "Path 90755",
    d: "M93.061,323.352a2.682,2.682,0,0,1,0-.49c.01-.347.023-.8.038-1.335a13.74,13.74,0,0,1,.7-4.353,8.4,8.4,0,0,1,2.491-3.619,5.677,5.677,0,0,1,1.131-.723,3.539,3.539,0,0,1,.336-.143c.078-.029.12-.042.122-.036a8.86,8.86,0,0,0-1.511,1,8.671,8.671,0,0,0-2.407,3.586,14.779,14.779,0,0,0-.742,4.3c-.036.562-.065,1.017-.094,1.332a2.661,2.661,0,0,1-.064.486",
    transform: "translate(-32.127 -107.948)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90756",
    "data-name": "Path 90756",
    d: "M88.4,297.909a1,1,0,0,1,.056.206c.033.154.076.352.128.6.109.519.255,1.272.43,2.2.348,1.864.794,4.446,1.221,7.307s.754,5.462.965,7.346c.106.942.185,1.7.233,2.233l.051.608a1.013,1.013,0,0,1,.007.213,1.017,1.017,0,0,1-.041-.209c-.022-.156-.049-.356-.083-.6l-.287-2.226c-.242-1.88-.588-4.474-1.014-7.335s-.853-5.442-1.171-7.311l-.376-2.213c-.039-.247-.071-.447-.1-.6a.986.986,0,0,1-.022-.212",
    transform: "translate(-30.523 -102.858)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90757",
    "data-name": "Path 90757",
    d: "M86.012,317.252a9.146,9.146,0,0,0-5.954-5.864,1.928,1.928,0,0,0-2.062.284,1.892,1.892,0,0,0,.16,2.074,7.813,7.813,0,0,0,7.839,3.7",
    transform: "translate(-26.842 -107.457)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90758",
    "data-name": "Path 90758",
    d: "M82.286,314.782a2.4,2.4,0,0,1,.446.118,4.381,4.381,0,0,1,.511.179c.194.083.424.158.659.284a8.426,8.426,0,0,1,.767.412,8.975,8.975,0,0,1,.833.553,10.143,10.143,0,0,1,1.665,1.572,9.978,9.978,0,0,1,1.234,1.93,8.6,8.6,0,0,1,.379.926,7.432,7.432,0,0,1,.249.834,6.8,6.8,0,0,1,.141.7,4.046,4.046,0,0,1,.066.536,2.292,2.292,0,0,1,.019.461c-.039,0-.071-.655-.344-1.67a7.991,7.991,0,0,0-.266-.817,9.053,9.053,0,0,0-.388-.9,10.329,10.329,0,0,0-1.224-1.889,10.5,10.5,0,0,0-1.628-1.556,9.079,9.079,0,0,0-.812-.557c-.258-.172-.515-.3-.747-.425-.939-.477-1.573-.655-1.561-.691",
    transform: "translate(-28.41 -108.683)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90759",
    "data-name": "Path 90759",
    d: "M285.111,390.694a4.584,4.584,0,0,1,2.756,2.3,8.081,8.081,0,0,1,.866,3.555,14.276,14.276,0,0,1-2.015,7.029c-2.232-1.416-3.145-4.343-3.516-5.857-.585-2.393-.189-7.073,1.909-7.025",
    transform: "translate(-97.695 -134.893)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90760",
    "data-name": "Path 90760",
    d: "M292.97,412.75a3.909,3.909,0,0,1,.684-3.866,5.19,5.19,0,0,1,3.6-1.764,2.187,2.187,0,0,1,1.776.49,1.673,1.673,0,0,1,.283,1.671,3.389,3.389,0,0,1-1.053,1.412c-1.541,1.332-3.277,2.339-5.294,2.056",
    transform: "translate(-101.067 -140.56)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90761",
    "data-name": "Path 90761",
    d: "M290.922,421.621a2.763,2.763,0,0,1,0-.49c.01-.348.023-.8.038-1.335a13.739,13.739,0,0,1,.7-4.353,8.4,8.4,0,0,1,2.491-3.62,5.7,5.7,0,0,1,1.131-.723,3.536,3.536,0,0,1,.336-.143.364.364,0,0,1,.122-.037,8.947,8.947,0,0,0-1.511,1,8.671,8.671,0,0,0-2.407,3.586,14.779,14.779,0,0,0-.742,4.3c-.036.562-.065,1.017-.094,1.332a2.657,2.657,0,0,1-.064.486",
    transform: "translate(-100.442 -141.876)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90762",
    "data-name": "Path 90762",
    d: "M286.266,396.178a1.007,1.007,0,0,1,.056.206c.033.154.076.352.128.6.109.519.255,1.272.43,2.2.348,1.864.794,4.446,1.221,7.307s.754,5.462.965,7.346c.106.942.185,1.7.233,2.233.021.25.038.452.051.609a1.006,1.006,0,0,1,.007.213,1.021,1.021,0,0,1-.041-.21c-.022-.156-.049-.356-.083-.6l-.287-2.226c-.242-1.88-.588-4.474-1.014-7.335s-.853-5.442-1.171-7.311c-.156-.919-.284-1.669-.376-2.213-.039-.247-.071-.447-.1-.6a.985.985,0,0,1-.022-.212",
    transform: "translate(-98.837 -136.787)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90763",
    "data-name": "Path 90763",
    d: "M283.873,415.521a9.146,9.146,0,0,0-5.954-5.864,1.928,1.928,0,0,0-2.062.284,1.892,1.892,0,0,0,.16,2.074,7.813,7.813,0,0,0,7.839,3.7",
    transform: "translate(-95.157 -141.386)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90764",
    "data-name": "Path 90764",
    d: "M280.147,413.052a2.424,2.424,0,0,1,.446.118,4.5,4.5,0,0,1,.511.179c.194.083.424.158.659.284a8.245,8.245,0,0,1,.767.412,8.97,8.97,0,0,1,.833.553,10.168,10.168,0,0,1,1.665,1.572,9.959,9.959,0,0,1,1.233,1.93,8.584,8.584,0,0,1,.379.926,7.489,7.489,0,0,1,.249.835,6.817,6.817,0,0,1,.141.7,4.039,4.039,0,0,1,.066.537,2.285,2.285,0,0,1,.019.46c-.039,0-.071-.654-.344-1.67a7.984,7.984,0,0,0-.266-.816,9.066,9.066,0,0,0-.388-.906,10.353,10.353,0,0,0-1.224-1.889,10.526,10.526,0,0,0-1.628-1.556,9.36,9.36,0,0,0-.812-.557c-.258-.172-.515-.3-.747-.425-.939-.476-1.573-.655-1.561-.691",
    transform: "translate(-96.725 -142.612)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90765",
    "data-name": "Path 90765",
    d: "M621.03,295.639a4.586,4.586,0,0,1,1.957,3.009,8.089,8.089,0,0,1-.22,3.651,14.273,14.273,0,0,1-4,6.124c-1.716-2.01-1.727-5.077-1.635-6.632.146-2.459,1.9-6.814,3.894-6.151",
    transform: "translate(-213.065 -102.051)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90766",
    "data-name": "Path 90766",
    d: "M622.269,319.368a3.91,3.91,0,0,1,1.793-3.493,5.192,5.192,0,0,1,3.963-.624,2.184,2.184,0,0,1,1.552.992,1.673,1.673,0,0,1-.221,1.681,3.393,3.393,0,0,1-1.421,1.039c-1.865.819-3.82,1.27-5.665.405",
    transform: "translate(-214.844 -108.796)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90767",
    "data-name": "Path 90767",
    d: "M616.8,327.354a2.7,2.7,0,0,1,.141-.469l.43-1.264a13.726,13.726,0,0,1,1.954-3.953,8.4,8.4,0,0,1,3.446-2.726,5.688,5.688,0,0,1,1.294-.358,3.4,3.4,0,0,1,.363-.037.361.361,0,0,1,.128,0,8.982,8.982,0,0,0-1.738.507,8.671,8.671,0,0,0-3.356,2.718,14.789,14.789,0,0,0-1.976,3.889c-.2.527-.361.954-.481,1.246a2.611,2.611,0,0,1-.2.447",
    transform: "translate(-212.959 -109.982)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90768",
    "data-name": "Path 90768",
    d: "M619.842,300.921a.992.992,0,0,1-.007.213c-.013.158-.031.359-.053.608-.049.528-.13,1.291-.238,2.233-.216,1.884-.551,4.482-.985,7.342s-.888,5.441-1.241,7.3c-.176.932-.325,1.685-.435,2.2-.053.246-.1.443-.13.6a1.03,1.03,0,0,1-.057.206.988.988,0,0,1,.022-.213c.026-.155.058-.355.1-.6.094-.543.223-1.293.382-2.211.323-1.867.756-4.45,1.191-7.309s.788-5.451,1.034-7.33c.122-.923.221-1.678.293-2.225l.086-.6a1,1,0,0,1,.041-.21",
    transform: "translate(-212.923 -103.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90769",
    "data-name": "Path 90769",
    d: "M613.286,318.866a9.146,9.146,0,0,0-3.962-7.357,1.929,1.929,0,0,0-2.055-.336,1.893,1.893,0,0,0-.458,2.03,7.814,7.814,0,0,0,6.4,5.849",
    transform: "translate(-209.48 -107.373)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90770",
    "data-name": "Path 90770",
    d: "M610.684,315.245a2.346,2.346,0,0,1,.391.244,4.316,4.316,0,0,1,.435.321c.161.136.359.276.546.466a8.107,8.107,0,0,1,.612.619,9.133,9.133,0,0,1,.634.774,10.139,10.139,0,0,1,1.127,1.993,9.946,9.946,0,0,1,.611,2.207,8.671,8.671,0,0,1,.09,1,7.473,7.473,0,0,1-.008.871,6.594,6.594,0,0,1-.072.714,3.958,3.958,0,0,1-.095.533,2.358,2.358,0,0,1-.117.446c-.039-.007.124-.646.162-1.7a8,8,0,0,0-.013-.859,9.1,9.1,0,0,0-.1-.979,10.326,10.326,0,0,0-.613-2.166,10.582,10.582,0,0,0-1.1-1.966,9.573,9.573,0,0,0-.613-.772,8.549,8.549,0,0,0-.589-.626c-.757-.731-1.31-1.089-1.288-1.12",
    transform: "translate(-210.848 -108.843)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18462",
    "data-name": "Rectangle 18462",
    width: 51.072,
    height: 94.796,
    transform: "translate(44.809 38.691)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18463",
    "data-name": "Rectangle 18463",
    width: 86.451,
    height: 69.205,
    transform: "translate(95.251 64.282)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44361",
    "data-name": "Group 44361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44360",
    "data-name": "Group 44360",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90771",
    "data-name": "Path 90771",
    d: "M146.3,154.831c-.094,0-.17-20.86-.17-46.586s.076-46.59.17-46.59.17,20.855.17,46.59-.076,46.586-.17,46.586",
    transform: "translate(-50.454 -21.288)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18464",
    "data-name": "Rectangle 18464",
    width: 136.894,
    height: 31.173,
    transform: "translate(44.809 102.315)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90772",
    "data-name": "Path 90772",
    d: "M120.37,45.371,93.249,31.409,66.268,45.371Z",
    transform: "translate(-22.88 -10.844)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18465",
    "data-name": "Rectangle 18465",
    width: 54.101,
    height: 3.121,
    transform: "translate(43.388 34.527)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18466",
    "data-name": "Rectangle 18466",
    width: 52.616,
    height: 1.043,
    transform: "translate(44.045 37.649)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90773",
    "data-name": "Path 90773",
    d: "M66.186,57.412c0-.094,12.124-.17,27.076-.17s27.078.076,27.078.17-12.121.17-27.078.17-27.076-.076-27.076-.17",
    transform: "translate(-22.852 -19.764)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90774",
    "data-name": "Path 90774",
    d: "M67.207,59.005c0-.094,11.789-.17,26.328-.17s26.33.076,26.33.17-11.786.17-26.33.17-26.328-.076-26.328-.17",
    transform: "translate(-23.204 -20.314)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18467",
    "data-name": "Rectangle 18467",
    width: 10.973,
    height: 18.861,
    transform: "translate(74.305 49.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18468",
    "data-name": "Rectangle 18468",
    width: 8.602,
    height: 16.412,
    transform: "translate(75.52 51.2)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90775",
    "data-name": "Path 90775",
    d: "M122.088,94.664c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-42.094 -26.979)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90776",
    "data-name": "Path 90776",
    d: "M115.345,85.669a27.271,27.271,0,0,1,4.3-.17,27.281,27.281,0,0,1,4.3.17,27.283,27.283,0,0,1-4.3.17,27.272,27.272,0,0,1-4.3-.17",
    transform: "translate(-39.825 -29.52)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90777",
    "data-name": "Path 90777",
    d: "M115.345,94.518a27.271,27.271,0,0,1,4.3-.17,27.282,27.282,0,0,1,4.3.17,27.282,27.282,0,0,1-4.3.17,27.271,27.271,0,0,1-4.3-.17",
    transform: "translate(-39.825 -32.575)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18469",
    "data-name": "Rectangle 18469",
    width: 10.973,
    height: 18.861,
    transform: "translate(142.259 72.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18470",
    "data-name": "Rectangle 18470",
    width: 8.602,
    height: 16.412,
    transform: "translate(143.474 73.968)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90778",
    "data-name": "Path 90778",
    d: "M225.876,129.438c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-77.929 -38.985)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90779",
    "data-name": "Path 90779",
    d: "M219.133,120.444a54.419,54.419,0,0,1,8.6,0,54.416,54.416,0,0,1-8.6,0",
    transform: "translate(-75.659 -41.526)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90780",
    "data-name": "Path 90780",
    d: "M219.133,129.293a54.419,54.419,0,0,1,8.6,0,54.414,54.414,0,0,1-8.6,0",
    transform: "translate(-75.659 -44.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18471",
    "data-name": "Rectangle 18471",
    width: 10.973,
    height: 18.861,
    transform: "translate(162.288 72.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18472",
    "data-name": "Rectangle 18472",
    width: 8.602,
    height: 16.412,
    transform: "translate(163.504 73.968)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90781",
    "data-name": "Path 90781",
    d: "M256.469,129.438c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-88.491 -38.985)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90782",
    "data-name": "Path 90782",
    d: "M249.726,120.444a54.419,54.419,0,0,1,8.6,0,54.416,54.416,0,0,1-8.6,0",
    transform: "translate(-86.222 -41.526)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90783",
    "data-name": "Path 90783",
    d: "M249.726,129.293a54.419,54.419,0,0,1,8.6,0,54.414,54.414,0,0,1-8.6,0",
    transform: "translate(-86.222 -44.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18473",
    "data-name": "Rectangle 18473",
    width: 10.973,
    height: 18.861,
    transform: "translate(124.252 72.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18474",
    "data-name": "Rectangle 18474",
    width: 8.602,
    height: 16.412,
    transform: "translate(125.468 73.748)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90784",
    "data-name": "Path 90784",
    d: "M198.375,129.1c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-68.433 -38.869)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90785",
    "data-name": "Path 90785",
    d: "M191.632,120.107a27.26,27.26,0,0,1,4.3-.17,27.283,27.283,0,0,1,4.3.17,27.281,27.281,0,0,1-4.3.17,27.258,27.258,0,0,1-4.3-.17",
    transform: "translate(-66.164 -41.41)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90786",
    "data-name": "Path 90786",
    d: "M191.632,128.956a27.258,27.258,0,0,1,4.3-.17,27.28,27.28,0,0,1,4.3.17,27.282,27.282,0,0,1-4.3.17,27.259,27.259,0,0,1-4.3-.17",
    transform: "translate(-66.164 -44.465)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18475",
    "data-name": "Rectangle 18475",
    width: 10.973,
    height: 18.861,
    transform: "translate(106.246 72.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18476",
    "data-name": "Rectangle 18476",
    width: 8.602,
    height: 16.412,
    transform: "translate(107.462 73.527)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90787",
    "data-name": "Path 90787",
    d: "M170.873,128.765c-.094,0-.17-3.7-.17-8.262s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.262-.17,8.262",
    transform: "translate(-58.938 -38.753)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90788",
    "data-name": "Path 90788",
    d: "M164.13,119.77a27.271,27.271,0,0,1,4.3-.17,27.281,27.281,0,0,1,4.3.17,27.282,27.282,0,0,1-4.3.17,27.272,27.272,0,0,1-4.3-.17",
    transform: "translate(-56.668 -41.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90789",
    "data-name": "Path 90789",
    d: "M164.13,128.62a27.269,27.269,0,0,1,4.3-.17,27.279,27.279,0,0,1,4.3.17,27.284,27.284,0,0,1-4.3.17,27.273,27.273,0,0,1-4.3-.17",
    transform: "translate(-56.668 -44.349)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18477",
    "data-name": "Rectangle 18477",
    width: 10.973,
    height: 18.861,
    transform: "translate(54.932 49.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18478",
    "data-name": "Rectangle 18478",
    width: 8.602,
    height: 16.412,
    transform: "translate(56.147 51.2)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90790",
    "data-name": "Path 90790",
    d: "M92.5,94.664c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-31.878 -26.979)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90791",
    "data-name": "Path 90791",
    d: "M85.756,85.669a27.271,27.271,0,0,1,4.3-.17,27.281,27.281,0,0,1,4.3.17,27.283,27.283,0,0,1-4.3.17,27.272,27.272,0,0,1-4.3-.17",
    transform: "translate(-29.609 -29.52)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90792",
    "data-name": "Path 90792",
    d: "M85.756,94.518a27.271,27.271,0,0,1,4.3-.17,27.282,27.282,0,0,1,4.3.17,27.282,27.282,0,0,1-4.3.17,27.271,27.271,0,0,1-4.3-.17",
    transform: "translate(-29.609 -32.575)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18479",
    "data-name": "Rectangle 18479",
    width: 10.973,
    height: 18.861,
    transform: "translate(74.305 73.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18480",
    "data-name": "Rectangle 18480",
    width: 8.602,
    height: 16.412,
    transform: "translate(75.52 75.351)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90793",
    "data-name": "Path 90793",
    d: "M122.088,131.551c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-42.094 -39.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90794",
    "data-name": "Path 90794",
    d: "M115.345,122.557a27.271,27.271,0,0,1,4.3-.17,27.281,27.281,0,0,1,4.3.17,27.282,27.282,0,0,1-4.3.17,27.271,27.271,0,0,1-4.3-.17",
    transform: "translate(-39.825 -42.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90795",
    "data-name": "Path 90795",
    d: "M115.345,131.406a27.27,27.27,0,0,1,4.3-.17,27.28,27.28,0,0,1,4.3.17,27.282,27.282,0,0,1-4.3.17,27.271,27.271,0,0,1-4.3-.17",
    transform: "translate(-39.825 -45.311)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18481",
    "data-name": "Rectangle 18481",
    width: 10.973,
    height: 18.861,
    transform: "translate(54.932 73.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18482",
    "data-name": "Rectangle 18482",
    width: 8.602,
    height: 16.412,
    transform: "translate(56.147 75.351)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90796",
    "data-name": "Path 90796",
    d: "M92.5,131.551c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-31.878 -39.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90797",
    "data-name": "Path 90797",
    d: "M85.756,122.557a27.271,27.271,0,0,1,4.3-.17,27.281,27.281,0,0,1,4.3.17,27.282,27.282,0,0,1-4.3.17,27.271,27.271,0,0,1-4.3-.17",
    transform: "translate(-29.609 -42.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90798",
    "data-name": "Path 90798",
    d: "M85.756,131.406a27.27,27.27,0,0,1,4.3-.17,27.28,27.28,0,0,1,4.3.17,27.282,27.282,0,0,1-4.3.17,27.271,27.271,0,0,1-4.3-.17",
    transform: "translate(-29.609 -45.311)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18483",
    "data-name": "Rectangle 18483",
    width: 138.695,
    height: 3.192,
    transform: "translate(43.243 97.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18484",
    "data-name": "Rectangle 18484",
    width: 137.868,
    height: 2.138,
    transform: "translate(44.071 100.176)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90799",
    "data-name": "Path 90799",
    d: "M205.067,153.306c0,.094-30.913.17-69.036.17s-69.042-.076-69.042-.17,30.905-.17,69.042-.17,69.036.076,69.036.17",
    transform: "translate(-23.129 -52.873)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90800",
    "data-name": "Path 90800",
    d: "M205.067,156.179c0,.094-30.913.17-69.036.17s-69.042-.076-69.042-.17,30.905-.17,69.042-.17,69.036.076,69.036.17",
    transform: "translate(-23.129 -53.865)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90801",
    "data-name": "Path 90801",
    d: "M205.067,148.2c0,.094-30.913.17-69.036.17s-69.042-.076-69.042-.17,30.905-.17,69.042-.17,69.036.076,69.036.17",
    transform: "translate(-23.129 -51.109)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90802",
    "data-name": "Path 90802",
    d: "M202.7,185.882H214.23v-19.3a5.271,5.271,0,0,0-5.271-5.271h-.991a5.27,5.27,0,0,0-5.27,5.271Z",
    transform: "translate(-69.984 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90803",
    "data-name": "Path 90803",
    d: "M205.19,185.044h8.264v-17.25a3.777,3.777,0,0,0-3.777-3.777h-.71a3.777,3.777,0,0,0-3.777,3.777Z",
    transform: "translate(-70.845 -56.629)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90804",
    "data-name": "Path 90804",
    d: "M211.411,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-72.934 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90805",
    "data-name": "Path 90805",
    d: "M205.272,173.932a49.858,49.858,0,0,1,8.233,0,49.862,49.862,0,0,1-8.233,0",
    transform: "translate(-70.873 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90806",
    "data-name": "Path 90806",
    d: "M205.272,184.449a49.862,49.862,0,0,1,8.233,0,49.858,49.858,0,0,1-8.233,0",
    transform: "translate(-70.873 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90807",
    "data-name": "Path 90807",
    d: "M236.236,185.882h11.533v-19.3a5.27,5.27,0,0,0-5.271-5.271h-.991a5.271,5.271,0,0,0-5.271,5.271Z",
    transform: "translate(-81.564 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90808",
    "data-name": "Path 90808",
    d: "M238.73,185.044h8.264v-17.25a3.777,3.777,0,0,0-3.777-3.777h-.71a3.777,3.777,0,0,0-3.777,3.777Z",
    transform: "translate(-82.425 -56.629)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90809",
    "data-name": "Path 90809",
    d: "M244.951,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-84.514 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90810",
    "data-name": "Path 90810",
    d: "M238.812,173.932a49.857,49.857,0,0,1,8.233,0,49.862,49.862,0,0,1-8.233,0",
    transform: "translate(-82.454 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90811",
    "data-name": "Path 90811",
    d: "M238.812,184.449a49.862,49.862,0,0,1,8.233,0,49.857,49.857,0,0,1-8.233,0",
    transform: "translate(-82.454 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90812",
    "data-name": "Path 90812",
    d: "M163.191,185.882h11.532v-19.3a5.27,5.27,0,0,0-5.271-5.271h-.991a5.271,5.271,0,0,0-5.271,5.271Z",
    transform: "translate(-56.344 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90813",
    "data-name": "Path 90813",
    d: "M165.743,185.436h8.264v-17.25a3.777,3.777,0,0,0-3.777-3.777h-.71a3.777,3.777,0,0,0-3.777,3.777Z",
    transform: "translate(-57.225 -56.765)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90814",
    "data-name": "Path 90814",
    d: "M171.906,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-59.295 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90815",
    "data-name": "Path 90815",
    d: "M165.767,173.932a25,25,0,0,1,4.116-.17,25,25,0,0,1,4.117.17,25,25,0,0,1-4.117.17,25,25,0,0,1-4.116-.17",
    transform: "translate(-57.234 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90816",
    "data-name": "Path 90816",
    d: "M165.767,184.449a25,25,0,0,1,4.116-.17,25,25,0,0,1,4.117.17,25,25,0,0,1-4.117.17,25,25,0,0,1-4.116-.17",
    transform: "translate(-57.234 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90817",
    "data-name": "Path 90817",
    d: "M78.183,185.882H89.715v-19.3a5.271,5.271,0,0,0-5.271-5.271h-.991a5.271,5.271,0,0,0-5.271,5.271Z",
    transform: "translate(-26.994 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90818",
    "data-name": "Path 90818",
    d: "M80.735,185.436H89v-17.25a3.777,3.777,0,0,0-3.777-3.777h-.71a3.777,3.777,0,0,0-3.777,3.777Z",
    transform: "translate(-27.875 -56.765)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90819",
    "data-name": "Path 90819",
    d: "M86.9,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-29.944 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90820",
    "data-name": "Path 90820",
    d: "M80.758,173.932a25,25,0,0,1,4.116-.17,25,25,0,0,1,4.117.17,25,25,0,0,1-4.117.17,25,25,0,0,1-4.116-.17",
    transform: "translate(-27.883 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90821",
    "data-name": "Path 90821",
    d: "M80.758,184.449a25,25,0,0,1,4.116-.17,25,25,0,0,1,4.117.17,25,25,0,0,1-4.117.17,25,25,0,0,1-4.116-.17",
    transform: "translate(-27.883 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90822",
    "data-name": "Path 90822",
    d: "M113.133,185.882h11.532v-19.3a5.271,5.271,0,0,0-5.271-5.271H118.4a5.27,5.27,0,0,0-5.271,5.271Z",
    transform: "translate(-39.061 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90823",
    "data-name": "Path 90823",
    d: "M115.685,185.436h8.264v-17.25a3.777,3.777,0,0,0-3.777-3.777h-.71a3.777,3.777,0,0,0-3.777,3.777Z",
    transform: "translate(-39.942 -56.765)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90824",
    "data-name": "Path 90824",
    d: "M121.848,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-42.011 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90825",
    "data-name": "Path 90825",
    d: "M115.709,173.932a25,25,0,0,1,4.116-.17,25,25,0,0,1,4.117.17,25,25,0,0,1-4.117.17,25,25,0,0,1-4.116-.17",
    transform: "translate(-39.95 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90826",
    "data-name": "Path 90826",
    d: "M115.709,184.449a25,25,0,0,1,4.116-.17,25,25,0,0,1,4.117.17,25,25,0,0,1-4.117.17,25,25,0,0,1-4.116-.17",
    transform: "translate(-39.95 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18485",
    "data-name": "Rectangle 18485",
    width: 51.072,
    height: 94.796,
    transform: "translate(376.081 38.691)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18486",
    "data-name": "Rectangle 18486",
    width: 86.451,
    height: 69.205,
    transform: "translate(290.258 64.282)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90827",
    "data-name": "Path 90827",
    d: "M574.363,154.831c-.095,0-.17-20.86-.17-46.586s.075-46.59.17-46.59.17,20.855.17,46.59-.076,46.586-.17,46.586",
    transform: "translate(-198.249 -21.288)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18487",
    "data-name": "Rectangle 18487",
    width: 136.894,
    height: 31.173,
    transform: "translate(290.258 102.315)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90828",
    "data-name": "Path 90828",
    d: "M308.04,107.43a1.314,1.314,0,0,1-.012-.2c0-.145-.007-.326-.012-.551-.007-.5-.015-1.2-.026-2.094-.014-1.83-.035-4.433-.06-7.638s-.038-7.03-.06-11.263a4.963,4.963,0,0,0-1.138-2.9,5.04,5.04,0,0,0-2.775-1.677,7.921,7.921,0,0,0-1.71-.111,5.461,5.461,0,0,0-1.713.209,5.011,5.011,0,0,0-2.752,2.074,4.72,4.72,0,0,0-.659,1.564,7.06,7.06,0,0,0-.13,1.694q0,1.73,0,3.41c0,2.237-.007,4.4-.009,6.46-.013,4.12-.024,7.85-.034,11.019l-.124-.124,8.17.066,2.246.031.592.013a1.452,1.452,0,0,1,.211.013.9.9,0,0,1-.185.013l-.57.013-2.218.031-8.246.066H296.7v-.125c-.01-3.169-.021-6.9-.034-11.019,0-2.063-.006-4.224-.009-6.46q0-1.678,0-3.41a5.682,5.682,0,0,1,.843-3.443,5.343,5.343,0,0,1,2.942-2.214,5.782,5.782,0,0,1,1.81-.221,8.255,8.255,0,0,1,1.78.121,5.364,5.364,0,0,1,2.956,1.8,5.283,5.283,0,0,1,1.2,3.091c.02,4.3-.018,8.142-.032,11.375-.025,3.2-.045,5.8-.06,7.628-.011.873-.02,1.562-.026,2.057-.005.217-.009.39-.012.528a.81.81,0,0,1-.012.172",
    transform: "translate(-102.421 -27.85)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18488",
    "data-name": "Rectangle 18488",
    width: 110.638,
    height: 76.95,
    transform: "translate(179.04 38.667)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44356",
    "data-name": "Group 44356",
    transform: "translate(179.04 38.667)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44355",
    "data-name": "Group 44355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44354",
    "data-name": "Group 44354",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18489",
    "data-name": "Rectangle 18489",
    width: 110.638,
    height: 76.95,
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18491",
    "data-name": "Rectangle 18491",
    width: 117.18,
    height: 3.516,
    transform: "translate(176.015 39.553)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18492",
    "data-name": "Rectangle 18492",
    width: 116.469,
    height: 1.184,
    transform: "translate(176.471 36.037)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18493",
    "data-name": "Rectangle 18493",
    width: 118.068,
    height: 2.747,
    transform: "translate(176.015 33.289)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18494",
    "data-name": "Rectangle 18494",
    width: 114.25,
    height: 3.538,
    transform: "translate(177.42 36.037)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90829",
    "data-name": "Path 90829",
    d: "M269.523,36.1H387.14L327.71,8.13Z",
    transform: "translate(-93.057 -2.807)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18495",
    "data-name": "Rectangle 18495",
    width: 114.119,
    height: 1.791,
    transform: "translate(177.42 43.069)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18496",
    "data-name": "Rectangle 18496",
    width: 6.9,
    height: 70.756,
    transform: "translate(179.04 44.86)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90830",
    "data-name": "Path 90830",
    d: "M280.264,139.184s-.008-.129-.012-.37-.007-.6-.012-1.064c-.005-.944-.013-2.315-.024-4.08-.012-3.548-.029-8.673-.05-15.035-.018-12.72-.044-30.383-.072-50.208l.17.17h-6.9l.171-.17c-.045,31.552-.084,58.69-.1,70.756l-.07-.07,5.11.04,1.33.016c.3.005.461.014.461.014s-.143.009-.436.014l-1.314.016-5.15.04h-.069v-.07c-.017-12.067-.056-39.2-.1-70.756v-.17h7.241v.17c-.028,19.874-.054,37.58-.072,50.332-.022,6.345-.039,11.457-.05,15-.01,1.747-.018,3.105-.024,4.04-.005.449-.009.8-.012,1.042s-.012.347-.012.347",
    transform: "translate(-94.325 -23.567)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18497",
    "data-name": "Rectangle 18497",
    width: 6.9,
    height: 70.756,
    transform: "translate(199.928 44.86)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90831",
    "data-name": "Path 90831",
    d: "M312.168,139.184s-.008-.129-.012-.37-.007-.6-.012-1.064c-.005-.944-.013-2.315-.024-4.08-.012-3.548-.029-8.673-.05-15.035-.018-12.72-.044-30.383-.072-50.208l.17.17h-6.9l.171-.17c-.045,31.552-.084,58.69-.1,70.756l-.07-.07,5.11.04,1.33.016c.3.005.461.014.461.014s-.143.009-.436.014l-1.314.016-5.15.04H305.2v-.07c-.017-12.067-.056-39.2-.1-70.756v-.17h7.241v.17c-.028,19.874-.054,37.58-.072,50.332-.022,6.345-.039,11.457-.05,15-.01,1.747-.018,3.105-.024,4.04-.005.449-.009.8-.012,1.042s-.012.347-.012.347",
    transform: "translate(-105.34 -23.567)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18498",
    "data-name": "Rectangle 18498",
    width: 6.9,
    height: 70.756,
    transform: "translate(264.596 44.86)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90832",
    "data-name": "Path 90832",
    d: "M410.938,139.184s-.008-.129-.012-.37-.007-.6-.012-1.064c-.005-.944-.013-2.315-.024-4.08-.012-3.548-.029-8.673-.05-15.035-.018-12.72-.044-30.383-.072-50.208l.17.17h-6.9l.171-.17c-.045,31.552-.084,58.69-.1,70.756l-.07-.07,5.11.04,1.33.016c.3.005.461.014.461.014s-.143.009-.436.014l-1.314.016-5.15.04h-.069v-.07c-.017-12.067-.056-39.2-.1-70.756v-.17h7.241v.17c-.028,19.874-.054,37.58-.072,50.332-.022,6.345-.039,11.457-.05,15-.01,1.747-.018,3.105-.024,4.04-.005.449-.009.8-.012,1.042s-.012.347-.012.347",
    transform: "translate(-139.442 -23.567)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18499",
    "data-name": "Rectangle 18499",
    width: 6.9,
    height: 70.756,
    transform: "translate(283.482 44.86)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90833",
    "data-name": "Path 90833",
    d: "M439.783,139.184s-.008-.129-.012-.37-.007-.6-.012-1.064c-.005-.944-.013-2.315-.024-4.08-.012-3.548-.029-8.673-.05-15.035-.018-12.72-.044-30.383-.072-50.208l.17.17h-6.9l.17-.17c-.045,31.552-.084,58.69-.1,70.756l-.069-.07,5.109.04,1.33.016c.3.005.461.014.461.014s-.143.009-.436.014l-1.314.016-5.149.04h-.07v-.07c-.017-12.067-.056-39.2-.1-70.756v-.17h7.241v.17c-.028,19.874-.054,37.58-.072,50.332-.022,6.345-.039,11.457-.05,15-.01,1.747-.018,3.105-.024,4.04-.005.449-.009.8-.012,1.042s-.012.347-.012.347",
    transform: "translate(-149.401 -23.567)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90834",
    "data-name": "Path 90834",
    d: "M334.267,111.287H323.048V89.816a5.128,5.128,0,0,1,5.127-5.128h.964a5.128,5.128,0,0,1,5.127,5.128Z",
    transform: "translate(-111.537 -29.24)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90835",
    "data-name": "Path 90835",
    d: "M334.173,111.2a1.318,1.318,0,0,1-.012-.2c0-.144-.007-.325-.012-.551-.007-.5-.015-1.2-.026-2.094-.014-1.83-.035-4.433-.06-7.638s-.038-7.03-.06-11.263a4.963,4.963,0,0,0-1.138-2.9,5.04,5.04,0,0,0-2.775-1.677,7.93,7.93,0,0,0-1.711-.111,5.461,5.461,0,0,0-1.713.209,5.011,5.011,0,0,0-2.752,2.074,4.734,4.734,0,0,0-.659,1.564,7.06,7.06,0,0,0-.13,1.694q0,1.73,0,3.41c0,2.237-.007,4.4-.009,6.46-.013,4.12-.024,7.85-.034,11.019l-.124-.124,8.17.067,2.246.031.591.013a1.452,1.452,0,0,1,.211.013.894.894,0,0,1-.185.013l-.57.013-2.218.031-8.246.066h-.124V111.2c-.01-3.169-.021-6.9-.034-11.019,0-2.063-.006-4.224-.009-6.46q0-1.678,0-3.41a5.682,5.682,0,0,1,.843-3.443,5.343,5.343,0,0,1,2.942-2.214,5.782,5.782,0,0,1,1.81-.221,8.255,8.255,0,0,1,1.78.121,5.364,5.364,0,0,1,2.956,1.8,5.278,5.278,0,0,1,1.2,3.091c.02,4.3-.018,8.142-.032,11.375-.025,3.2-.045,5.8-.06,7.628-.011.873-.02,1.562-.026,2.057-.005.217-.009.39-.012.528a.807.807,0,0,1-.012.172",
    transform: "translate(-111.444 -29.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90836",
    "data-name": "Path 90836",
    d: "M331.525,111.2c-.094,0-.17-5.87-.17-13.11s.076-13.11.17-13.11.17,5.869.17,13.11-.076,13.11-.17,13.11",
    transform: "translate(-114.406 -29.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90837",
    "data-name": "Path 90837",
    d: "M334.267,93.841a92.5,92.5,0,0,1-11.219,0,92.508,92.508,0,0,1,11.219,0",
    transform: "translate(-111.537 -32.341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90838",
    "data-name": "Path 90838",
    d: "M334.267,103.9a92.5,92.5,0,0,1-11.219,0,92.508,92.508,0,0,1,11.219,0",
    transform: "translate(-111.537 -35.815)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90839",
    "data-name": "Path 90839",
    d: "M334.267,113.961a92.508,92.508,0,0,1-11.219,0,92.508,92.508,0,0,1,11.219,0",
    transform: "translate(-111.537 -39.288)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90840",
    "data-name": "Path 90840",
    d: "M363.5,111.287H352.285V89.816a5.128,5.128,0,0,1,5.127-5.128h.964a5.128,5.128,0,0,1,5.127,5.128Z",
    transform: "translate(-121.632 -29.24)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90841",
    "data-name": "Path 90841",
    d: "M363.41,111.2a1.318,1.318,0,0,1-.012-.2c0-.144-.007-.325-.012-.551-.007-.5-.015-1.2-.026-2.094-.014-1.83-.035-4.433-.06-7.638s-.038-7.03-.06-11.263a4.963,4.963,0,0,0-1.138-2.9,5.038,5.038,0,0,0-2.775-1.677,7.93,7.93,0,0,0-1.711-.111,5.461,5.461,0,0,0-1.713.209,5.011,5.011,0,0,0-2.752,2.074,4.734,4.734,0,0,0-.659,1.564,7.058,7.058,0,0,0-.13,1.694q0,1.73,0,3.41c0,2.237-.006,4.4-.009,6.46-.012,4.12-.024,7.85-.034,11.019l-.124-.124,8.17.067,2.246.031.592.013a1.436,1.436,0,0,1,.21.013.894.894,0,0,1-.185.013l-.569.013-2.219.031-8.246.066h-.124V111.2c-.01-3.169-.021-6.9-.034-11.019,0-2.063-.006-4.224-.009-6.46q0-1.678,0-3.41a5.682,5.682,0,0,1,.843-3.443,5.344,5.344,0,0,1,2.942-2.214,5.776,5.776,0,0,1,1.81-.221,8.264,8.264,0,0,1,1.781.121,5.363,5.363,0,0,1,2.955,1.8,5.278,5.278,0,0,1,1.2,3.091c.02,4.3-.018,8.142-.032,11.375-.025,3.2-.045,5.8-.06,7.628-.011.873-.02,1.562-.026,2.057-.005.217-.009.39-.012.528a.809.809,0,0,1-.012.172",
    transform: "translate(-121.538 -29.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90842",
    "data-name": "Path 90842",
    d: "M360.762,111.2c-.094,0-.17-5.87-.17-13.11s.076-13.11.17-13.11.17,5.869.17,13.11-.076,13.11-.17,13.11",
    transform: "translate(-124.5 -29.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90843",
    "data-name": "Path 90843",
    d: "M363.5,93.841a92.5,92.5,0,0,1-11.219,0,92.509,92.509,0,0,1,11.219,0",
    transform: "translate(-121.632 -32.341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90844",
    "data-name": "Path 90844",
    d: "M363.5,103.9a92.5,92.5,0,0,1-11.219,0,92.509,92.509,0,0,1,11.219,0",
    transform: "translate(-121.632 -35.815)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90845",
    "data-name": "Path 90845",
    d: "M363.5,113.961a92.509,92.509,0,0,1-11.219,0,92.509,92.509,0,0,1,11.219,0",
    transform: "translate(-121.632 -39.288)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90846",
    "data-name": "Path 90846",
    d: "M392.741,111.287H381.522V89.816a5.128,5.128,0,0,1,5.127-5.128h.964a5.128,5.128,0,0,1,5.127,5.128Z",
    transform: "translate(-131.727 -29.24)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90847",
    "data-name": "Path 90847",
    d: "M392.647,111.2a1.329,1.329,0,0,1-.012-.2c0-.144-.007-.325-.012-.551-.007-.5-.015-1.2-.026-2.094-.014-1.83-.035-4.433-.06-7.638s-.038-7.03-.06-11.263a4.963,4.963,0,0,0-1.138-2.9,5.038,5.038,0,0,0-2.775-1.677,7.93,7.93,0,0,0-1.711-.111,5.461,5.461,0,0,0-1.713.209,5.011,5.011,0,0,0-2.752,2.074,4.734,4.734,0,0,0-.659,1.564,7.063,7.063,0,0,0-.13,1.694q0,1.73,0,3.41c0,2.237-.007,4.4-.009,6.46-.012,4.12-.024,7.85-.034,11.019l-.124-.124,8.17.067,2.246.031.592.013a1.436,1.436,0,0,1,.21.013.894.894,0,0,1-.185.013l-.57.013-2.218.031-8.246.066H381.3V111.2c-.01-3.169-.021-6.9-.034-11.019,0-2.063-.006-4.224-.009-6.46q0-1.678,0-3.41a5.682,5.682,0,0,1,.843-3.443,5.345,5.345,0,0,1,2.942-2.214,5.782,5.782,0,0,1,1.81-.221,8.264,8.264,0,0,1,1.781.121,5.363,5.363,0,0,1,2.955,1.8,5.278,5.278,0,0,1,1.2,3.091c.02,4.3-.018,8.142-.032,11.375-.025,3.2-.045,5.8-.06,7.628-.011.873-.02,1.562-.026,2.057-.005.217-.009.39-.012.528a.807.807,0,0,1-.012.172",
    transform: "translate(-131.633 -29.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90848",
    "data-name": "Path 90848",
    d: "M390,111.2c-.094,0-.17-5.87-.17-13.11s.076-13.11.17-13.11.17,5.869.17,13.11-.076,13.11-.17,13.11",
    transform: "translate(-134.595 -29.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90849",
    "data-name": "Path 90849",
    d: "M392.741,93.841a92.5,92.5,0,0,1-11.219,0,92.508,92.508,0,0,1,11.219,0",
    transform: "translate(-131.727 -32.341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90850",
    "data-name": "Path 90850",
    d: "M392.741,103.9a92.5,92.5,0,0,1-11.219,0,92.508,92.508,0,0,1,11.219,0",
    transform: "translate(-131.727 -35.815)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90851",
    "data-name": "Path 90851",
    d: "M392.741,113.961a92.508,92.508,0,0,1-11.219,0,92.508,92.508,0,0,1,11.219,0",
    transform: "translate(-131.727 -39.288)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18500",
    "data-name": "Rectangle 18500",
    width: 8.785,
    height: 17.423,
    transform: "translate(213.944 96.985)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18501",
    "data-name": "Rectangle 18501",
    width: 8.785,
    height: 17.423,
    transform: "translate(231.151 96.985)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18502",
    "data-name": "Rectangle 18502",
    width: 8.785,
    height: 17.423,
    transform: "translate(248.357 96.985)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18503",
    "data-name": "Rectangle 18503",
    width: 115.87,
    height: 3.671,
    transform: "translate(176.776 114.408)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18504",
    "data-name": "Rectangle 18504",
    width: 119.31,
    height: 3.671,
    transform: "translate(174.236 118.025)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18505",
    "data-name": "Rectangle 18505",
    width: 129.223,
    height: 3.67,
    transform: "translate(168.872 125.367)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18506",
    "data-name": "Rectangle 18506",
    width: 138.144,
    height: 3.671,
    transform: "translate(164.101 132.676)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18507",
    "data-name": "Rectangle 18507",
    width: 124.281,
    height: 3.671,
    transform: "translate(171.379 121.696)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18508",
    "data-name": "Rectangle 18508",
    width: 133.383,
    height: 3.671,
    transform: "translate(166.576 129.038)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90852",
    "data-name": "Path 90852",
    d: "M385.67,68.427c0,.094-25.38.17-56.68.17s-56.686-.076-56.686-.17,25.375-.17,56.686-.17,56.68.076,56.68.17",
    transform: "translate(-94.017 -23.567)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90853",
    "data-name": "Path 90853",
    d: "M386.25,65.645c0,.094-26.133.171-58.362.171s-58.368-.077-58.368-.171,26.127-.17,58.368-.17,58.362.076,58.362.17",
    transform: "translate(-93.056 -22.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90854",
    "data-name": "Path 90854",
    d: "M386.464,60.254c0,.094-26.133.17-58.362.17s-58.368-.076-58.368-.17,26.127-.17,58.368-.17,58.362.076,58.362.17",
    transform: "translate(-93.13 -20.745)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90855",
    "data-name": "Path 90855",
    d: "M386.464,56.783c0,.094-26.133.17-58.362.17s-58.368-.076-58.368-.17,26.127-.17,58.368-.17,58.362.076,58.362.17",
    transform: "translate(-93.13 -19.547)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90856",
    "data-name": "Path 90856",
    d: "M385.531,55.012c0,.094-26.133.17-58.362.17s-58.368-.076-58.368-.17,26.127-.17,58.368-.17,58.362.076,58.362.17",
    transform: "translate(-92.808 -18.935)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90857",
    "data-name": "Path 90857",
    d: "M384.258,174.436c0,.094-25.447.17-56.83.17s-56.836-.076-56.836-.17,25.442-.17,56.836-.17,56.83.076,56.83.17",
    transform: "translate(-93.426 -60.168)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90858",
    "data-name": "Path 90858",
    d: "M384.258,179.985c0,.094-25.447.17-56.83.17s-56.836-.076-56.836-.17,25.442-.17,56.836-.17,56.83.076,56.83.17",
    transform: "translate(-93.426 -62.084)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90859",
    "data-name": "Path 90859",
    d: "M381.347,185.566c0,.094-26.683.207-59.591.251s-59.6,0-59.6-.09,26.678-.206,59.6-.251,59.591,0,59.591.09",
    transform: "translate(-90.515 -64.032)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90860",
    "data-name": "Path 90860",
    d: "M379.505,191.388c0,.094-27.219.17-60.788.17s-60.794-.076-60.794-.17,27.213-.17,60.794-.17,60.788.076,60.788.17",
    transform: "translate(-89.052 -66.021)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90861",
    "data-name": "Path 90861",
    d: "M378.883,196.994c0,.094-27.729.17-61.927.17s-61.933-.076-61.933-.17,27.723-.17,61.933-.17,61.927.076,61.927.17",
    transform: "translate(-88.051 -67.957)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90862",
    "data-name": "Path 90862",
    d: "M377.369,202.6c0,.095-28.372.171-63.363.171s-63.369-.076-63.369-.171,28.366-.17,63.369-.17,63.363.076,63.363.17",
    transform: "translate(-86.536 -69.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90863",
    "data-name": "Path 90863",
    d: "M384.258,208.158c0,.094-25.447.17-56.83.17s-56.836-.076-56.836-.17,25.442-.17,56.836-.17,56.83.076,56.83.17",
    transform: "translate(-93.426 -71.811)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90864",
    "data-name": "Path 90864",
    d: "M571.944,45.371l27.122-13.963,26.98,13.963Z",
    transform: "translate(-197.473 -10.844)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18509",
    "data-name": "Rectangle 18509",
    width: 54.101,
    height: 3.121,
    transform: "translate(374.472 34.527)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18510",
    "data-name": "Rectangle 18510",
    width: 52.616,
    height: 1.043,
    transform: "translate(375.301 37.649)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90865",
    "data-name": "Path 90865",
    d: "M626.1,57.412c0,.094-12.124.17-27.076.17s-27.078-.076-27.078-.17,12.121-.17,27.078-.17,27.076.076,27.076.17",
    transform: "translate(-197.473 -19.764)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90866",
    "data-name": "Path 90866",
    d: "M625.869,59.005c0,.094-11.788.17-26.328.17s-26.33-.076-26.33-.17,11.786-.17,26.33-.17,26.328.076,26.328.17",
    transform: "translate(-197.91 -20.314)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18511",
    "data-name": "Rectangle 18511",
    width: 10.973,
    height: 18.861,
    transform: "translate(386.683 49.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18512",
    "data-name": "Rectangle 18512",
    width: 8.602,
    height: 16.412,
    transform: "translate(387.838 51.2)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90867",
    "data-name": "Path 90867",
    d: "M598.575,94.664c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-206.609 -26.979)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90868",
    "data-name": "Path 90868",
    d: "M600.962,85.669a54.419,54.419,0,0,1-8.6,0,54.417,54.417,0,0,1,8.6,0",
    transform: "translate(-204.522 -29.52)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90869",
    "data-name": "Path 90869",
    d: "M600.962,94.518a54.419,54.419,0,0,1-8.6,0,54.419,54.419,0,0,1,8.6,0",
    transform: "translate(-204.522 -32.575)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18513",
    "data-name": "Rectangle 18513",
    width: 10.973,
    height: 18.861,
    transform: "translate(300.723 72.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18514",
    "data-name": "Rectangle 18514",
    width: 8.602,
    height: 16.412,
    transform: "translate(301.879 74.189)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90870",
    "data-name": "Path 90870",
    d: "M467.285,129.775c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-161.279 -39.101)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90871",
    "data-name": "Path 90871",
    d: "M469.672,120.78a54.419,54.419,0,0,1-8.6,0,54.414,54.414,0,0,1,8.6,0",
    transform: "translate(-159.192 -41.642)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90872",
    "data-name": "Path 90872",
    d: "M469.672,129.629a54.414,54.414,0,0,1-8.6,0,54.419,54.419,0,0,1,8.6,0",
    transform: "translate(-159.192 -44.698)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18515",
    "data-name": "Rectangle 18515",
    width: 10.973,
    height: 18.861,
    transform: "translate(318.73 72.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18516",
    "data-name": "Rectangle 18516",
    width: 8.602,
    height: 16.412,
    transform: "translate(319.885 73.968)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90873",
    "data-name": "Path 90873",
    d: "M494.787,129.438c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-170.774 -38.985)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90874",
    "data-name": "Path 90874",
    d: "M497.174,120.444a54.416,54.416,0,0,1-8.6,0,54.419,54.419,0,0,1,8.6,0",
    transform: "translate(-168.687 -41.526)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90875",
    "data-name": "Path 90875",
    d: "M497.174,129.293a54.414,54.414,0,0,1-8.6,0,54.419,54.419,0,0,1,8.6,0",
    transform: "translate(-168.687 -44.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18517",
    "data-name": "Rectangle 18517",
    width: 10.973,
    height: 18.861,
    transform: "translate(336.736 72.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18518",
    "data-name": "Rectangle 18518",
    width: 8.602,
    height: 16.412,
    transform: "translate(337.891 73.748)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90876",
    "data-name": "Path 90876",
    d: "M522.289,129.1c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-180.27 -38.869)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90877",
    "data-name": "Path 90877",
    d: "M524.676,120.107a54.417,54.417,0,0,1-8.6,0,54.419,54.419,0,0,1,8.6,0",
    transform: "translate(-178.183 -41.41)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90878",
    "data-name": "Path 90878",
    d: "M524.676,128.956a54.419,54.419,0,0,1-8.6,0,54.414,54.414,0,0,1,8.6,0",
    transform: "translate(-178.183 -44.465)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18519",
    "data-name": "Rectangle 18519",
    width: 10.973,
    height: 18.861,
    transform: "translate(354.743 72.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18520",
    "data-name": "Rectangle 18520",
    width: 8.602,
    height: 16.412,
    transform: "translate(355.898 73.527)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90879",
    "data-name": "Path 90879",
    d: "M549.791,128.765c-.094,0-.17-3.7-.17-8.262s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.262-.17,8.262",
    transform: "translate(-189.765 -38.753)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90880",
    "data-name": "Path 90880",
    d: "M552.178,119.77a54.417,54.417,0,0,1-8.6,0,54.417,54.417,0,0,1,8.6,0",
    transform: "translate(-187.678 -41.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90881",
    "data-name": "Path 90881",
    d: "M552.178,128.62a54.419,54.419,0,0,1-8.6,0,54.419,54.419,0,0,1,8.6,0",
    transform: "translate(-187.678 -44.349)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18521",
    "data-name": "Rectangle 18521",
    width: 10.973,
    height: 18.861,
    transform: "translate(406.056 49.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18522",
    "data-name": "Rectangle 18522",
    width: 8.602,
    height: 16.412,
    transform: "translate(407.211 51.2)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90882",
    "data-name": "Path 90882",
    d: "M628.164,94.664c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-216.825 -26.979)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90883",
    "data-name": "Path 90883",
    d: "M630.551,85.669a54.419,54.419,0,0,1-8.6,0,54.417,54.417,0,0,1,8.6,0",
    transform: "translate(-214.738 -29.52)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90884",
    "data-name": "Path 90884",
    d: "M630.551,94.518a54.419,54.419,0,0,1-8.6,0,54.419,54.419,0,0,1,8.6,0",
    transform: "translate(-214.738 -32.575)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18523",
    "data-name": "Rectangle 18523",
    width: 10.973,
    height: 18.861,
    transform: "translate(386.683 73.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18524",
    "data-name": "Rectangle 18524",
    width: 8.602,
    height: 16.412,
    transform: "translate(387.838 75.351)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90885",
    "data-name": "Path 90885",
    d: "M598.575,131.551c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-206.609 -39.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90886",
    "data-name": "Path 90886",
    d: "M600.962,122.557a54.419,54.419,0,0,1-8.6,0,54.417,54.417,0,0,1,8.6,0",
    transform: "translate(-204.522 -42.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90887",
    "data-name": "Path 90887",
    d: "M600.962,131.406a54.419,54.419,0,0,1-8.6,0,54.414,54.414,0,0,1,8.6,0",
    transform: "translate(-204.522 -45.311)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18525",
    "data-name": "Rectangle 18525",
    width: 10.973,
    height: 18.861,
    transform: "translate(406.056 73.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18526",
    "data-name": "Rectangle 18526",
    width: 8.602,
    height: 16.412,
    transform: "translate(407.211 75.351)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90888",
    "data-name": "Path 90888",
    d: "M628.164,131.551c-.094,0-.17-3.7-.17-8.263s.076-8.263.17-8.263.17,3.7.17,8.263-.076,8.263-.17,8.263",
    transform: "translate(-216.825 -39.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90889",
    "data-name": "Path 90889",
    d: "M630.551,122.557a54.419,54.419,0,0,1-8.6,0,54.417,54.417,0,0,1,8.6,0",
    transform: "translate(-214.738 -42.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90890",
    "data-name": "Path 90890",
    d: "M630.551,131.406a54.419,54.419,0,0,1-8.6,0,54.414,54.414,0,0,1,8.6,0",
    transform: "translate(-214.738 -45.311)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18527",
    "data-name": "Rectangle 18527",
    width: 138.695,
    height: 3.192,
    transform: "translate(290.022 97.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18528",
    "data-name": "Rectangle 18528",
    width: 137.868,
    height: 2.138,
    transform: "translate(290.022 100.176)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90891",
    "data-name": "Path 90891",
    d: "M442.962,153.306c0-.094,30.913-.17,69.036-.17s69.042.076,69.042.17-30.905.17-69.042.17-69.036-.076-69.036-.17",
    transform: "translate(-152.94 -52.873)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90892",
    "data-name": "Path 90892",
    d: "M442.962,156.179c0-.094,30.913-.17,69.036-.17s69.042.076,69.042.17-30.905.17-69.042.17-69.036-.076-69.036-.17",
    transform: "translate(-152.94 -53.865)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90893",
    "data-name": "Path 90893",
    d: "M442.962,148.2c0-.094,30.913-.17,69.036-.17s69.042.076,69.042.17-30.905.17-69.042.17-69.036-.076-69.036-.17",
    transform: "translate(-152.94 -51.109)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90894",
    "data-name": "Path 90894",
    d: "M478.79,185.882H467.258v-19.3a5.271,5.271,0,0,1,5.271-5.271h.991a5.271,5.271,0,0,1,5.271,5.271Z",
    transform: "translate(-161.328 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90895",
    "data-name": "Path 90895",
    d: "M478.021,185.044h-8.264v-17.25a3.777,3.777,0,0,1,3.777-3.777h.71a3.777,3.777,0,0,1,3.778,3.777Z",
    transform: "translate(-162.191 -56.629)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90896",
    "data-name": "Path 90896",
    d: "M475.977,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-164.28 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90897",
    "data-name": "Path 90897",
    d: "M477.955,173.932a49.862,49.862,0,0,1-8.233,0,49.858,49.858,0,0,1,8.233,0",
    transform: "translate(-162.179 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90898",
    "data-name": "Path 90898",
    d: "M477.955,184.448a49.858,49.858,0,0,1-8.233,0,49.862,49.862,0,0,1,8.233,0",
    transform: "translate(-162.179 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90899",
    "data-name": "Path 90899",
    d: "M518.379,185.882H506.846v-19.3a5.27,5.27,0,0,1,5.271-5.271h.991a5.271,5.271,0,0,1,5.271,5.271Z",
    transform: "translate(-174.997 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90900",
    "data-name": "Path 90900",
    d: "M517.609,185.044h-8.264v-17.25a3.777,3.777,0,0,1,3.776-3.777h.71a3.777,3.777,0,0,1,3.777,3.777Z",
    transform: "translate(-175.859 -56.629)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90901",
    "data-name": "Path 90901",
    d: "M515.565,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-177.948 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90902",
    "data-name": "Path 90902",
    d: "M517.543,173.932a49.862,49.862,0,0,1-8.233,0,49.857,49.857,0,0,1,8.233,0",
    transform: "translate(-175.847 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90903",
    "data-name": "Path 90903",
    d: "M517.543,184.448a49.857,49.857,0,0,1-8.233,0,49.862,49.862,0,0,1,8.233,0",
    transform: "translate(-175.847 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90904",
    "data-name": "Path 90904",
    d: "M555.109,185.882H543.576v-19.3a5.271,5.271,0,0,1,5.271-5.271h.991a5.271,5.271,0,0,1,5.271,5.271Z",
    transform: "translate(-187.678 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90905",
    "data-name": "Path 90905",
    d: "M554.28,185.436h-8.264v-17.25a3.777,3.777,0,0,1,3.776-3.777h.71a3.777,3.777,0,0,1,3.777,3.777Z",
    transform: "translate(-188.521 -56.765)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90906",
    "data-name": "Path 90906",
    d: "M552.3,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-190.63 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90907",
    "data-name": "Path 90907",
    d: "M554.273,173.932a49.87,49.87,0,0,1-8.234,0,49.866,49.866,0,0,1,8.234,0",
    transform: "translate(-188.529 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90908",
    "data-name": "Path 90908",
    d: "M554.273,184.448a49.866,49.866,0,0,1-8.234,0,49.87,49.87,0,0,1,8.234,0",
    transform: "translate(-188.529 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90909",
    "data-name": "Path 90909",
    d: "M636.58,185.882H625.047v-19.3a5.271,5.271,0,0,1,5.271-5.271h.991a5.271,5.271,0,0,1,5.271,5.271Z",
    transform: "translate(-215.807 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90910",
    "data-name": "Path 90910",
    d: "M635.751,185.436h-8.264v-17.25a3.777,3.777,0,0,1,3.776-3.777h.71a3.777,3.777,0,0,1,3.777,3.777Z",
    transform: "translate(-216.65 -56.765)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90911",
    "data-name": "Path 90911",
    d: "M633.766,185.044c-.094,0-.17-4.708-.17-10.513s.076-10.514.17-10.514.17,4.706.17,10.514-.076,10.513-.17,10.513",
    transform: "translate(-218.759 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90912",
    "data-name": "Path 90912",
    d: "M635.743,173.932a49.862,49.862,0,0,1-8.233,0,49.857,49.857,0,0,1,8.233,0",
    transform: "translate(-216.658 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90913",
    "data-name": "Path 90913",
    d: "M635.743,184.448a49.857,49.857,0,0,1-8.233,0,49.862,49.862,0,0,1,8.233,0",
    transform: "translate(-216.658 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90914",
    "data-name": "Path 90914",
    d: "M601.7,185.882H590.166v-19.3a5.271,5.271,0,0,1,5.271-5.271h.991a5.271,5.271,0,0,1,5.271,5.271Z",
    transform: "translate(-203.764 -55.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90915",
    "data-name": "Path 90915",
    d: "M600.871,185.436h-8.264v-17.25a3.776,3.776,0,0,1,3.777-3.777h.71a3.777,3.777,0,0,1,3.778,3.777Z",
    transform: "translate(-204.607 -56.765)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90916",
    "data-name": "Path 90916",
    d: "M598.886,185.044c-.095,0-.17-4.708-.17-10.513s.075-10.514.17-10.514.17,4.706.17,10.514-.075,10.513-.17,10.513",
    transform: "translate(-206.716 -56.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90917",
    "data-name": "Path 90917",
    d: "M600.863,173.932a49.863,49.863,0,0,1-8.233,0,49.858,49.858,0,0,1,8.233,0",
    transform: "translate(-204.615 -59.994)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90918",
    "data-name": "Path 90918",
    d: "M600.863,184.448a49.858,49.858,0,0,1-8.233,0,49.863,49.863,0,0,1,8.233,0",
    transform: "translate(-204.615 -63.625)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18529",
    "data-name": "Rectangle 18529",
    width: 88.753,
    height: 3.121,
    transform: "translate(288.642 60.118)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18530",
    "data-name": "Rectangle 18530",
    width: 86.315,
    height: 1.043,
    transform: "translate(290.001 63.239)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90919",
    "data-name": "Path 90919",
    d: "M529.515,91.73s-.162.008-.467.012l-1.347.012-5.161.024-18.966.052-62.811.07.17-.17v3.121l-.17-.17c42.917,0,78.951.054,88.751.128l-.042.042c.01-1.058.019-1.831.024-2.352s.018-.769.018-.769.01.234.018.745c.005.526.013,1.308.024,2.376v.042h-.043c-9.8.073-45.835.128-88.751.128h-.171V91.56h.171l62.937.07,18.927.052,5.12.024,1.325.012c.3,0,.443.012.443.012",
    transform: "translate(-152.122 -31.613)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90920",
    "data-name": "Path 90920",
    d: "M442.91,96.587a1.4,1.4,0,0,1,.018.26c0,.192.01.449.018.783l-.036-.036c4.266-.077,21.988-.135,43.191-.135s38.925.058,43.193.134l-.036.039c-.015-.334-.026-.592-.034-.784a1.4,1.4,0,0,1,0-.261,1.32,1.32,0,0,1,.036.259c.017.191.04.448.069.782l0,.038h-.039c-4.268.077-21.986.134-43.193.134s-38.925-.058-43.191-.134h-.037V97.63c.007-.334.013-.591.018-.783a1.327,1.327,0,0,1,.018-.26",
    transform: "translate(-152.909 -33.348)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90921",
    "data-name": "Path 90921",
    d: "M529.6,87.646H440.852l1.727-7.916h85.582Z",
    transform: "translate(-152.211 -27.528)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90922",
    "data-name": "Path 90922",
    d: "M267.3,33.289l-2.91-2.961L325.99,0l62.441,30.645-3.064,2.644L325.938,5.323Z",
    transform: "translate(-91.285 0)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44359",
    "data-name": "Group 44359",
    transform: "translate(176.467 5.323)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44358",
    "data-name": "Group 44358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44357",
    "data-name": "Group 44357",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90923",
    "data-name": "Path 90923",
    d: "M269.523,36.1H387.14L327.71,8.13Z",
    transform: "translate(-269.524 -8.13)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_90924",
    "data-name": "Path 90924",
    d: "M362,27.192a8.583,8.583,0,1,1-8.583-8.583A8.583,8.583,0,0,1,362,27.192",
    transform: "translate(-119.059 -6.425)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18532",
    "data-name": "Rectangle 18532",
    width: 88.753,
    height: 3.121,
    transform: "translate(94.567 60.118)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18533",
    "data-name": "Rectangle 18533",
    width: 86.315,
    height: 1.043,
    transform: "translate(95.644 63.239)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90925",
    "data-name": "Path 90925",
    d: "M144.414,91.73s.146-.008.443-.012l1.325-.012,5.12-.024,18.927-.052,62.937-.07h.171v3.462h-.171c-42.917,0-78.951-.054-88.751-.128h-.043v-.042c.01-1.069.019-1.85.024-2.376.007-.511.018-.745.018-.745s.01.255.018.769.014,1.294.024,2.352l-.042-.042c9.8-.074,45.835-.128,88.751-.128l-.17.17V91.73l.17.17-62.811-.07-18.966-.052-5.161-.024-1.347-.012c-.3,0-.467-.012-.467-.012",
    transform: "translate(-49.846 -31.612)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90926",
    "data-name": "Path 90926",
    d: "M232.34,96.587a1.4,1.4,0,0,1,.018.26c0,.192.01.449.018.783v.035h-.037c-4.266.077-21.988.134-43.191.134s-38.925-.058-43.193-.134h-.039l0-.038c.029-.333.052-.591.069-.782a1.315,1.315,0,0,1,.036-.259,1.424,1.424,0,0,1,0,.261c-.009.192-.02.45-.035.784l-.036-.039c4.268-.077,21.986-.134,43.193-.134s38.925.058,43.191.134l-.036.037c.007-.334.013-.591.018-.783a1.325,1.325,0,0,1,.018-.26",
    transform: "translate(-50.38 -33.348)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90927",
    "data-name": "Path 90927",
    d: "M144.436,87.646h88.753l-1.727-7.916H145.88Z",
    transform: "translate(-49.869 -27.528)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44369",
    "data-name": "Group 44369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44368",
    "data-name": "Group 44368",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90928",
    "data-name": "Path 90928",
    d: "M531.943,120.139a3.369,3.369,0,0,1,3.176,1.992,2.271,2.271,0,0,0,.433.842,2.693,2.693,0,0,0,1.168.447,2.7,2.7,0,0,1,1.938,2.469,4.63,4.63,0,0,1,2.371.759,1.45,1.45,0,0,1,.247,2.135,2.477,2.477,0,0,1,.627,3.811,4.008,4.008,0,0,1,2.72,3.7,3.776,3.776,0,0,1,2.214.852,1.211,1.211,0,0,1-.291,1.951,1.889,1.889,0,0,1-.206,2.551A1.566,1.566,0,0,1,547,144.1a1.723,1.723,0,0,1-2.632-.3,2.841,2.841,0,0,1-1.608,2.2,3.044,3.044,0,0,1-.118,3.549,1.6,1.6,0,0,1,1.243,1.861,1.725,1.725,0,0,1-1.978,1.188,4.224,4.224,0,0,1-.606,2.21,1.989,1.989,0,0,1-2.067.869,3.556,3.556,0,0,1,.083,3.716,5.691,5.691,0,0,1-.773.862l-1.729,1.686c-.551.537-1.451,1.1-2.022.593a3.159,3.159,0,0,1-4.437,1.089c-.51,1.605-2.652,2.02-4.4,2.148a3.26,3.26,0,0,1-1.63-.158c-.773-.366-1.074-1.25-1.613-1.893-.295-.352-.669-.638-.944-1a2.5,2.5,0,0,1,.325-3.247c-1.177-1.243-1.174-3.113-1.105-4.8a9.7,9.7,0,0,1,.824-4.247,1,1,0,0,0,.183-.6c-.046-.277-.331-.443-.572-.6a3.6,3.6,0,0,1-1.542-3.7,2.469,2.469,0,0,0,.13-1.234,2.11,2.11,0,0,0-.627-.814c-1.216-1.186-1.982-3.227-.791-4.465a4.79,4.79,0,0,1-1.9-5.846,3.758,3.758,0,0,1-1.8-5.043,5.648,5.648,0,0,1-1.859-2.562,1.994,1.994,0,0,1,1.442-2.474c-.548-.423.93.82,1.252.213s.062-2.077.384-2.684c.572-1.076,1.321-2.113,2.368-2.311a2.383,2.383,0,0,1,2.67,1.146,1.233,1.233,0,0,1,1.23-.957,3.668,3.668,0,0,1,1.635.454,2.218,2.218,0,0,1,3.6-.139,2.308,2.308,0,0,1,3.657.606",
    transform: "translate(-177.116 -40.726)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90929",
    "data-name": "Path 90929",
    d: "M543.218,148.7s.039.014.117.034a.717.717,0,0,0,.149.026,1.015,1.015,0,0,0,.21.007,1.791,1.791,0,0,0,1.218-.608,2.118,2.118,0,0,0,.494-.876,2.671,2.671,0,0,0,.026-1.2,4.363,4.363,0,0,0-.495-1.291,5.277,5.277,0,0,0-.416-.635.992.992,0,0,0-.682-.43l-.008.088a1.08,1.08,0,0,0,.776-.217,1.528,1.528,0,0,0,.511-.675,2.37,2.37,0,0,0-.158-1.76,4.558,4.558,0,0,0-1.07-1.59,2.485,2.485,0,0,0-.862-.54,1.385,1.385,0,0,0-1.044.056l.055.1a1.47,1.47,0,0,0,.672-1.019,3.132,3.132,0,0,0-.034-1.262,4.549,4.549,0,0,0-.447-1.215,2.116,2.116,0,0,0-.953-.926,1.518,1.518,0,0,0-1.349.063.994.994,0,0,0-.443.555.626.626,0,0,0,0,.375.5.5,0,0,0,.254.287.724.724,0,0,0,.724-.066,1.137,1.137,0,0,0,.392-.612,2.917,2.917,0,0,0,.007-1.429,3.418,3.418,0,0,0-2.85-2.6l.01.124a1.142,1.142,0,0,0,.694-.526,1.679,1.679,0,0,0,.225-.828,1.9,1.9,0,0,0-.645-1.5,3.249,3.249,0,0,0-1.454-.67,10.045,10.045,0,0,0-1.531-.179l.047.087a2.265,2.265,0,0,0,.035-2.041,2.62,2.62,0,0,0-1.377-1.359,3.369,3.369,0,0,0-1.8-.2,4.363,4.363,0,0,0-1.569.57l.054.006a5.033,5.033,0,0,0-2.586-1.282,5.352,5.352,0,0,0-2.18.058,4.958,4.958,0,0,0-1.281.5c-.136.079-.232.151-.3.194s-.1.071-.1.071.037-.018.105-.06.168-.107.306-.183a5.144,5.144,0,0,1,1.279-.477,5.353,5.353,0,0,1,2.156-.036,4.969,4.969,0,0,1,2.536,1.277l.024.023.029-.017a4.27,4.27,0,0,1,1.537-.55,3.262,3.262,0,0,1,1.745.2,2.514,2.514,0,0,1,1.317,1.308,2.154,2.154,0,0,1-.035,1.937l-.047.082.094.006a9.9,9.9,0,0,1,1.513.18,3.128,3.128,0,0,1,1.4.646,1.776,1.776,0,0,1,.6,1.406,1.553,1.553,0,0,1-.208.765,1.013,1.013,0,0,1-.618.469l-.354.088.363.037a3.293,3.293,0,0,1,2.737,2.5,2.8,2.8,0,0,1,0,1.364,1.017,1.017,0,0,1-.345.545.6.6,0,0,1-.592.055.41.41,0,0,1-.188-.513.879.879,0,0,1,.388-.483,1.394,1.394,0,0,1,1.234-.055,1.99,1.99,0,0,1,.9.871,4.417,4.417,0,0,1,.436,1.179,3.028,3.028,0,0,1,.036,1.213,1.352,1.352,0,0,1-.614.942l.054.1a1.267,1.267,0,0,1,.958-.052,2.383,2.383,0,0,1,.822.513,4.451,4.451,0,0,1,1.049,1.55,2.273,2.273,0,0,1,.164,1.684,1.207,1.207,0,0,1-1.186.84l-.008.088a.913.913,0,0,1,.621.395,5.267,5.267,0,0,1,.412.621,4.307,4.307,0,0,1,.5,1.265,2.619,2.619,0,0,1-.014,1.17,2.071,2.071,0,0,1-.472.858,1.781,1.781,0,0,1-1.184.617,1.92,1.92,0,0,1-.474-.042",
    transform: "translate(-181.006 -42.625)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90930",
    "data-name": "Path 90930",
    d: "M543.777,152.074a1.992,1.992,0,0,1,.406.811,2.016,2.016,0,0,1-.043,1.031,1.741,1.741,0,0,1-.8,1.034l-.166.094.19.009a2.693,2.693,0,0,1,1.44.528,2.583,2.583,0,0,1,.967,1.4,2.714,2.714,0,0,1-.347,2.17l-.1.149.17-.059a2.709,2.709,0,0,1,1.715-.005,3.015,3.015,0,0,1,1.178.693,3.171,3.171,0,0,1,.689,1.01.284.284,0,0,0-.022-.082,1.962,1.962,0,0,0-.087-.229,2.611,2.611,0,0,0-.529-.752,3.022,3.022,0,0,0-1.2-.737,2.785,2.785,0,0,0-1.787-.012l.07.09a2.82,2.82,0,0,0,.371-2.271,2.7,2.7,0,0,0-1.018-1.471,2.776,2.776,0,0,0-1.508-.539l.024.1a1.825,1.825,0,0,0,.832-1.105,2.037,2.037,0,0,0,.018-1.071,1.7,1.7,0,0,0-.3-.621,1.422,1.422,0,0,0-.123-.134c-.029-.029-.045-.043-.047-.041",
    transform: "translate(-187.54 -52.506)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90931",
    "data-name": "Path 90931",
    d: "M555.511,141.321c0,.012.138.018.378.076a2.581,2.581,0,0,1,.934.444,2.375,2.375,0,0,1,.862,1.234,2.482,2.482,0,0,1-.177,1.817,2.576,2.576,0,0,1-.139.234l-.067.1.122,0a2.382,2.382,0,0,1,1.63.589,2.28,2.28,0,0,1,.723,1.222,2.48,2.48,0,0,1,.029.969c-.039.227-.084.349-.073.352s.018-.027.042-.084a1.666,1.666,0,0,0,.079-.259,2.364,2.364,0,0,0,.01-1,2.332,2.332,0,0,0-.732-1.29,2.476,2.476,0,0,0-1.712-.631l.055.1a2.541,2.541,0,0,0,.323-2.157,2.419,2.419,0,0,0-.922-1.273,2.463,2.463,0,0,0-.977-.42,1.73,1.73,0,0,0-.288-.031.294.294,0,0,0-.1,0",
    transform: "translate(-191.799 -48.792)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90932",
    "data-name": "Path 90932",
    d: "M545.523,176.2a1.1,1.1,0,0,1-.113.254,1.638,1.638,0,0,1-.552.561,1.581,1.581,0,0,1-1.2.21,1.694,1.694,0,0,1-1.189-1.019l.058.018a2.775,2.775,0,0,1-2.163.418,2.694,2.694,0,0,1-1.128-.526,2.57,2.57,0,0,1-.769-1.054,2.811,2.811,0,0,1,.188-2.493l.044.067a2.819,2.819,0,0,1-2.288-.733,2.659,2.659,0,0,1-.824-1.723,2.761,2.761,0,0,1,.181-1.252,1.9,1.9,0,0,1,.211-.4c.009,0-.081.139-.183.414a2.808,2.808,0,0,0-.154,1.236,2.615,2.615,0,0,0,.82,1.673,2.751,2.751,0,0,0,2.223.7l.094-.014-.05.081a2.733,2.733,0,0,0-.177,2.411,2.485,2.485,0,0,0,.741,1.017,2.6,2.6,0,0,0,1.089.511,2.7,2.7,0,0,0,2.1-.394l.041-.028.018.046a1.633,1.633,0,0,0,1.131.985,1.543,1.543,0,0,0,1.158-.187,1.661,1.661,0,0,0,.555-.535c.1-.153.127-.245.134-.242",
    transform: "translate(-184.918 -58.187)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90933",
    "data-name": "Path 90933",
    d: "M493.076,158.549c-.011.031.208.162.66.2a2.607,2.607,0,0,0,2.579-1.712,2.746,2.746,0,0,0,.056-1.564,2.779,2.779,0,0,0-.914-1.477,2.431,2.431,0,0,0-.835-.452,1.773,1.773,0,0,0-1.025-.016,1.465,1.465,0,0,0-.839.653,1.2,1.2,0,0,0-.164.531,1.261,1.261,0,0,0,.086.532,1.5,1.5,0,0,0,.644.748,1.937,1.937,0,0,0,.868.245,2.71,2.71,0,0,0,1.517-.4,2.751,2.751,0,0,0,.952-.957,2.578,2.578,0,0,0,.342-1.048,2.5,2.5,0,0,0-.046-.819c-.1-.439-.264-.636-.295-.621s.037.244.063.654a2.581,2.581,0,0,1-.423,1.607,2.421,2.421,0,0,1-.841.752,2.268,2.268,0,0,1-1.233.276,1.389,1.389,0,0,1-.611-.186.931.931,0,0,1-.387-.463.623.623,0,0,1,.044-.553.884.884,0,0,1,.5-.38,1.513,1.513,0,0,1,1.313.352,2.265,2.265,0,0,1,.75,1.161,2.3,2.3,0,0,1,.005,1.268,2.272,2.272,0,0,1-.244.526,2.376,2.376,0,0,1-.351.416,2.664,2.664,0,0,1-1.516.692c-.407.039-.643-.009-.655.038",
    transform: "translate(-170.075 -52.615)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90934",
    "data-name": "Path 90934",
    d: "M527.826,124.311a15.167,15.167,0,0,0-8.354-4.109,13.888,13.888,0,0,0-2.532-.19c-.532.06-2.741.227-3.464,1.936l3-.959a40.165,40.165,0,0,1,9.837,15.549,2.986,2.986,0,0,0,.72,1.327,1.923,1.923,0,0,0,2.528-.284,4.6,4.6,0,0,0,1.069-2.545c.632-3.78-.154-7.958-2.806-10.725",
    transform: "translate(-177.286 -41.431)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90935",
    "data-name": "Path 90935",
    d: "M520.654,132.222a2.522,2.522,0,0,0-2.561-2.253l-9.288-2.941-2.339.444c-5.307.4-8.548,6.517-8.273,10.819.3,4.779.864,10.6,1.876,14.068,2.035,6.97,7.6,7.181,7.6,7.181s.133,2.975.259,5.355l3.738,4.427,7.746-6.1Z",
    transform: "translate(-172.003 -43.858)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90937",
    "data-name": "Path 90937",
    d: "M503.522,154.382a.92.92,0,0,0,1,.809.88.88,0,0,0,.835-.942.921.921,0,0,0-1-.809.88.88,0,0,0-.837.942",
    transform: "translate(-173.848 -52.977)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90938",
    "data-name": "Path 90938",
    d: "M501.432,149.184c.128.1.754-.494,1.736-.617s1.764.278,1.855.143c.046-.06-.1-.259-.439-.448a2.525,2.525,0,0,0-1.5-.263,2.43,2.43,0,0,0-1.363.64c-.272.27-.347.5-.285.545",
    transform: "translate(-173.12 -51.092)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90939",
    "data-name": "Path 90939",
    d: "M510.036,155.884a6.584,6.584,0,0,0-1.631-.085c-.254.007-.5-.014-.562-.179a1.292,1.292,0,0,1,.073-.764q.239-.956.5-2a33.162,33.162,0,0,0,1.03-5.2,33.058,33.058,0,0,0-1.446,5.11q-.244,1.052-.466,2.01a1.459,1.459,0,0,0,0,1,.634.634,0,0,0,.459.314,1.724,1.724,0,0,0,.433.005,6.443,6.443,0,0,0,1.617-.2",
    transform: "translate(-175.2 -50.978)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90940",
    "data-name": "Path 90940",
    d: "M512.677,175.194a13.265,13.265,0,0,0,9.172-2.825s-1.923,4.689-9.127,4.928Z",
    transform: "translate(-177.01 -59.513)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90941",
    "data-name": "Path 90941",
    d: "M500.842,145.965c.234.177.9-.217,1.765-.428.856-.239,1.632-.223,1.748-.49.048-.128-.118-.321-.486-.454a2.814,2.814,0,0,0-2.83.74c-.253.3-.3.544-.2.632",
    transform: "translate(-172.906 -49.88)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90942",
    "data-name": "Path 90942",
    d: "M518.533,152.841a.919.919,0,0,1-.8,1,.88.88,0,0,1-1.018-.741.921.921,0,0,1,.8-1,.881.881,0,0,1,1.019.742",
    transform: "translate(-178.402 -52.511)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90943",
    "data-name": "Path 90943",
    d: "M518.967,147.926c-.1.13-.843-.321-1.828-.231s-1.664.648-1.781.537c-.058-.049.039-.275.333-.532a2.526,2.526,0,0,1,1.413-.577,2.42,2.42,0,0,1,1.469.333c.324.206.446.412.395.471",
    transform: "translate(-177.93 -50.793)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90944",
    "data-name": "Path 90944",
    d: "M519.074,144.484c-.2.225-.959-.009-1.877-.02-.917-.039-1.7.151-1.874-.084-.079-.114.044-.339.384-.553a2.836,2.836,0,0,1,1.526-.368,2.8,2.8,0,0,1,1.5.452c.325.231.431.462.345.572",
    transform: "translate(-177.915 -49.532)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90945",
    "data-name": "Path 90945",
    d: "M530.046,153.007c.066-.53.831-1.7,1.365-1.723,1.425-.047,3.93.373,3.52,3.926-.56,4.857-5.321,3.292-5.313,3.152.006-.11.2-3.525.428-5.355",
    transform: "translate(-182.859 -52.232)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90946",
    "data-name": "Path 90946",
    d: "M531.974,157.649c.023-.013.078.069.213.151a.853.853,0,0,0,.631.086A2.108,2.108,0,0,0,534,156.119a2.81,2.81,0,0,0-.1-1.239.983.983,0,0,0-.562-.723.434.434,0,0,0-.526.174c-.081.128-.061.229-.088.234s-.095-.093-.032-.289a.541.541,0,0,1,.226-.283.646.646,0,0,1,.483-.069,1.2,1.2,0,0,1,.8.855,2.9,2.9,0,0,1,.137,1.387,2.21,2.21,0,0,1-1.476,1.955.912.912,0,0,1-.759-.218c-.137-.137-.149-.249-.132-.255",
    transform: "translate(-183.67 -53.139)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90947",
    "data-name": "Path 90947",
    d: "M517.056,130.587a25.71,25.71,0,0,1,9.85.619,4.68,4.68,0,0,1,2.569,1.364,4.6,4.6,0,0,1,.793,2.44,25.539,25.539,0,0,1-1.16,8.745l-3.136,2.409c-2.666-.313-1.995-4.931-2.13-7.191a5.339,5.339,0,0,1-3.641-4.323,5.909,5.909,0,0,1-3.144-4.063",
    transform: "translate(-178.522 -45.012)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90948",
    "data-name": "Path 90948",
    d: "M516.612,121.622c2.527-1.85,5.049.219,5.59,1.845a4.5,4.5,0,0,1,5.75,3.71.831.831,0,0,0,.751.929,4.427,4.427,0,0,1,1.161,7.865,3.788,3.788,0,0,1-1.032,4.867",
    transform: "translate(-178.368 -41.741)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90949",
    "data-name": "Path 90949",
    d: "M528.833,140.821a3.963,3.963,0,0,0,.946-1.092,3.916,3.916,0,0,0,.5-1.6,3.576,3.576,0,0,0-.464-2.141l-.028-.046.044-.031a4.484,4.484,0,0,0,1.865-3.951,4.465,4.465,0,0,0-2.023-3.32,3.944,3.944,0,0,0-.623-.333c-.218-.1-.442-.154-.685-.251a.743.743,0,0,1-.272-.2.765.765,0,0,1-.15-.3c-.054-.21-.063-.407-.1-.6a4.46,4.46,0,0,0-.361-1.1,4.419,4.419,0,0,0-5.261-2.351l-.058.018-.021-.058a4.04,4.04,0,0,0-1.767-2.065,3.642,3.642,0,0,0-1.07-.42,3.235,3.235,0,0,0-.973-.045,3.859,3.859,0,0,0-.769.172c-.208.1-.394.164-.53.246l-.311.187a.063.063,0,1,1-.011-.016l.3-.2c.135-.087.32-.16.529-.265a3.769,3.769,0,0,1,.78-.192,3.248,3.248,0,0,1,1,.029,3.684,3.684,0,0,1,1.1.418,4.125,4.125,0,0,1,1.836,2.114l-.079-.041a4.585,4.585,0,0,1,5.809,3.544c.039.2.05.405.1.585a.548.548,0,0,0,.338.393c.21.085.46.149.682.251a4.17,4.17,0,0,1,.645.346,4.54,4.54,0,0,1,1.065.953,4.477,4.477,0,0,1,1.019,2.485A4.594,4.594,0,0,1,529.9,136l.017-.077a3.651,3.651,0,0,1,.457,2.209,3.922,3.922,0,0,1-.536,1.628,3.522,3.522,0,0,1-.7.835c-.095.081-.175.134-.225.172a.4.4,0,0,1-.081.053",
    transform: "translate(-178.368 -41.723)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90950",
    "data-name": "Path 90950",
    d: "M517.115,128.509a2.97,2.97,0,0,1,3.386,4.07,2.526,2.526,0,0,1,.832,4.92,2.052,2.052,0,0,1,1.414,1.636,2.554,2.554,0,0,1-.677,2.1,2.089,2.089,0,0,1-1.4.712,1.354,1.354,0,0,1-1.306-.76,1.011,1.011,0,0,1,.548-1.321,1.7,1.7,0,0,1-1.326-1.607,4.661,4.661,0,0,1,.528-2.17,1.471,1.471,0,0,1-.488-2.27,2.977,2.977,0,0,1-2.709-1.8c-.107-.259.028-.713.27-.573a1.564,1.564,0,0,1-1.2-1.882",
    transform: "translate(-177.792 -44.346)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90951",
    "data-name": "Path 90951",
    d: "M493.96,137.826c-.918-1.151-1.449-1.952-.037-3.68-.325-2.722-.184-5.017,2.166-6.607a2.34,2.34,0,0,1,2.978-3.023,5.862,5.862,0,0,1,2.061-2.354,2.02,2.02,0,0,1,2.748.659,3.155,3.155,0,0,1,4.6-1.12,2.162,2.162,0,0,1,3.172,1.676l-1.376,2.5a2.382,2.382,0,0,1-.513,4.472,3.175,3.175,0,0,1-.318,3.326c-.338.431-1.139.694-1.333.183-.323.545-1.265.236-1.469-.363a2.54,2.54,0,0,1,.333-1.823,1.276,1.276,0,0,1-1.281-2.2l-1.525.31a2.693,2.693,0,0,1-.279,2.251,1.645,1.645,0,0,1-2.06.565,2.556,2.556,0,0,1-2.145,3.355.922.922,0,0,1-1.247-.475,3.392,3.392,0,0,1-.27-2.056s.024,2.717-1.074,3.153c-.409.162-.187,4.371-.27,5.022-.086.678-1.47.56-2.342.194a1.935,1.935,0,0,1-.623-.433,2.5,2.5,0,0,1-.113-3.249Z",
    transform: "translate(-170.235 -41.82)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90952",
    "data-name": "Path 90952",
    d: "M528.276,147.478a1.68,1.68,0,0,1-.722-2.534,1.756,1.756,0,0,1,.267-2.705,2.9,2.9,0,0,1-.6-2.959,2.515,2.515,0,0,1,2.516-1.564,2.225,2.225,0,0,1,1.944,2.151l.158,4.785a.81.81,0,0,1-.841,1.376,2.3,2.3,0,0,1,.674,2.072,1,1,0,0,1-.363.657.545.545,0,0,1-.442.073,1.186,1.186,0,0,1,.035,1.629,1.172,1.172,0,0,1-1.79-.338.787.787,0,0,1-1.046.015,1.58,1.58,0,0,1-.5-1.014,1.455,1.455,0,0,1,.7-1.644",
    transform: "translate(-181.968 -47.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90953",
    "data-name": "Path 90953",
    d: "M496.341,142.019a3.606,3.606,0,0,1-.37.075,2.023,2.023,0,0,1-1.679-.639,1.694,1.694,0,0,1-.409-.82,1.972,1.972,0,0,1,.091-1.052,1.869,1.869,0,0,1,.729-.924l.058-.037-.059-.033a2.081,2.081,0,0,1-.883-2.21,1.811,1.811,0,0,1,.743-1.151,1.272,1.272,0,0,1,.679-.229.8.8,0,0,1,.352.074.768.768,0,0,1,.278.232.55.55,0,0,1,.031.674.707.707,0,0,1-.692.2.839.839,0,0,1-.592-.474,1.828,1.828,0,0,1-.172-.8,2.952,2.952,0,0,1,.456-1.636,1.831,1.831,0,0,1,.61-.613,1.078,1.078,0,0,1,.835-.112l.162.047-.1-.139a3.159,3.159,0,0,1-.5-2.618,2.2,2.2,0,0,1,.488-.875,2.175,2.175,0,0,1,.827-.542,1.857,1.857,0,0,1,1.837.228l.083-.084a1.167,1.167,0,0,1-.15-1.187,1.583,1.583,0,0,1,.813-.892,2.389,2.389,0,0,1,1.188-.187,4.636,4.636,0,0,1,1.159.255l.093.032-.023-.1a2.051,2.051,0,0,1,.277-1.545,1.944,1.944,0,0,1,1.183-.881,2.074,2.074,0,0,1,1.374.163,2.025,2.025,0,0,1,.923.881l.031.062.039-.056a3.235,3.235,0,0,1,1.92-1.266,3.664,3.664,0,0,1,1.755.01,3.288,3.288,0,0,1,1.013.458c.1.073.177.139.229.177a.572.572,0,0,0,.081.059s-.1-.095-.3-.255a3.184,3.184,0,0,0-1.015-.482,3.67,3.67,0,0,0-1.782-.03,3.4,3.4,0,0,0-1.044.421,3.068,3.068,0,0,0-.929.86l.071.005a2.11,2.11,0,0,0-.957-.926,2.087,2.087,0,0,0-2.979,2.369l.07-.064a4.713,4.713,0,0,0-1.185-.265,2.5,2.5,0,0,0-1.245.194,1.7,1.7,0,0,0-.875.955,1.513,1.513,0,0,0-.1.669,1.125,1.125,0,0,0,.267.636l.083-.084a1.978,1.978,0,0,0-1.956-.249,2.287,2.287,0,0,0-.872.572,2.312,2.312,0,0,0-.517.923,3.276,3.276,0,0,0,.522,2.722l.065-.092a1.2,1.2,0,0,0-.928.123,1.947,1.947,0,0,0-.648.653,3.061,3.061,0,0,0-.473,1.7,1.925,1.925,0,0,0,.187.852,1.13,1.13,0,0,0,.272.346.891.891,0,0,0,.4.184.814.814,0,0,0,.8-.239.607.607,0,0,0,.123-.414.747.747,0,0,0-.155-.392.887.887,0,0,0-.317-.264.917.917,0,0,0-.4-.082,1.368,1.368,0,0,0-.735.248,1.9,1.9,0,0,0-.78,1.216,2.166,2.166,0,0,0,.936,2.3l0-.069a1.939,1.939,0,0,0-.754.968,2.023,2.023,0,0,0-.085,1.09,1.75,1.75,0,0,0,.431.844,2.016,2.016,0,0,0,.648.462,1.97,1.97,0,0,0,1.074.164,1.391,1.391,0,0,0,.367-.1",
    transform: "translate(-170.45 -42.704)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90954",
    "data-name": "Path 90954",
    d: "M529.726,145.076a.808.808,0,0,0,.305.1,1.313,1.313,0,0,0,.878-.209,1.529,1.529,0,0,0,.472-.46,1.5,1.5,0,0,0,.243-.74,2.325,2.325,0,0,0-.678-1.716l-.015.077a2.209,2.209,0,0,0,1.022-.96,2.188,2.188,0,0,0-2.385-3.225l.013.119a.628.628,0,0,0,.32-.091.884.884,0,0,0,.386-.539,1.528,1.528,0,0,0,0-.645,4.015,4.015,0,0,0-.414-1.158,1.744,1.744,0,0,0-.388-.464,1.136,1.136,0,0,0-.543-.247,1.113,1.113,0,0,0-.579.048.784.784,0,0,0-.431.372l-.084.162L528,135.4a2.242,2.242,0,0,0,.915-1.019,2.588,2.588,0,0,0,.189-.617,2.553,2.553,0,0,0,.019-.61,2.036,2.036,0,0,0-.4-1.019,2.244,2.244,0,0,0-.708-.613,2.277,2.277,0,0,0-1.271-.295,1.561,1.561,0,0,0-.458.093c0,.012.159-.044.46-.058a2.3,2.3,0,0,1,1.237.316,2.218,2.218,0,0,1,.678.6,1.966,1.966,0,0,1,.377.983,2.427,2.427,0,0,1-.023.586,2.485,2.485,0,0,1-.185.59,2.15,2.15,0,0,1-.877.967l.075.072a.823.823,0,0,1,.894-.357,1.247,1.247,0,0,1,.849.659,3.924,3.924,0,0,1,.4,1.12,1.405,1.405,0,0,1,.005.593.764.764,0,0,1-.331.466.509.509,0,0,1-.259.075l.012.119a2.077,2.077,0,0,1,2.265,3.057,2.118,2.118,0,0,1-.967.923l-.063.028.048.049a2.256,2.256,0,0,1,.669,1.645,1.452,1.452,0,0,1-.667,1.159,1.311,1.311,0,0,1-.845.227,2.1,2.1,0,0,1-.308-.068",
    transform: "translate(-181.708 -45.308)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90955",
    "data-name": "Path 90955",
    d: "M511.381,132.029a1.317,1.317,0,0,1,.178-.48,1.977,1.977,0,0,1,1.161-.733,3.9,3.9,0,0,1,.961-.124,2.044,2.044,0,0,1,1.055.263,1.313,1.313,0,0,1,.655.949.832.832,0,0,1-.153.581.6.6,0,0,1-.548.225.847.847,0,0,1-.552-.285,1.42,1.42,0,0,1-.3-.551,1.967,1.967,0,0,1,.016-1.194,2.028,2.028,0,0,1,.591-.913,1.843,1.843,0,0,1,.851-.42,2.149,2.149,0,0,1,1.368.166,3.792,3.792,0,0,1,.439.276,1.428,1.428,0,0,0-.418-.318,2.146,2.146,0,0,0-1.405-.207,1.907,1.907,0,0,0-.9.428,2.115,2.115,0,0,0-.631.954,2.073,2.073,0,0,0-.024,1.263,1.532,1.532,0,0,0,.327.6.965.965,0,0,0,.629.323.725.725,0,0,0,.653-.272.952.952,0,0,0,.175-.667,1.418,1.418,0,0,0-.716-1.032,2.127,2.127,0,0,0-1.112-.268,3.874,3.874,0,0,0-.983.141,1.988,1.988,0,0,0-1.178.79,1.041,1.041,0,0,0-.134.369.579.579,0,0,0,0,.136",
    transform: "translate(-176.562 -44.618)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90956",
    "data-name": "Path 90956",
    d: "M514.452,161.5c-.154-.014-.191,1.016-1.1,1.718s-2,.551-2.013.694c-.016.064.238.209.7.237a2.566,2.566,0,0,0,1.678-.522,2.234,2.234,0,0,0,.855-1.442c.054-.43-.052-.689-.123-.686",
    transform: "translate(-145.761 -133) rotate(9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90957",
    "data-name": "Path 90957",
    d: "M475.059,213.086c-.069.015-9.748,3.386-11.9,13.608s-2.3,36.035,1.691,37.11,13.06,0,13.06,0l7.221-29.863Z",
    transform: "translate(-159.396 -73.571)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44364",
    "data-name": "Group 44364",
    transform: "translate(307.197 140.995)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44363",
    "data-name": "Group 44363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44362",
    "data-name": "Group 44362",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90958",
    "data-name": "Path 90958",
    d: "M474.687,215.347l11.2,16.306a9.728,9.728,0,0,1,1.579,3c.475,1.857-.176,3.8-.82,5.6l-8.25,23.146-3.718,1.748a3.3,3.3,0,0,1-1.678-2.52,8.679,8.679,0,0,1,.249-3.123,52.442,52.442,0,0,1,2.459-8.177c.634-1.618,1.328-3.538.372-4.99-.729-1.108-2.15-1.484-3.272-2.193-2.5-1.582-3.42-4.8-3.582-7.749-.4-7.3,2.557-14.326,5.457-21.042",
    transform: "translate(-469.194 -215.347)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_90959",
    "data-name": "Path 90959",
    d: "M467.53,260.232a1.982,1.982,0,0,0-.041-.388c-.045-.282-.1-.647-.175-1.1-.083-.477-.177-1.06-.271-1.741s-.222-1.451-.318-2.31c-.227-1.713-.423-3.761-.581-6.039-.137-2.28-.221-4.79-.192-7.425s.194-5.144.4-7.418c.227-2.272.487-4.313.777-6.017.126-.854.282-1.62.4-2.3s.238-1.255.341-1.727c.091-.45.164-.812.221-1.091a1.872,1.872,0,0,0,.057-.386,1.94,1.94,0,0,0-.116.371c-.071.277-.162.635-.276,1.08-.12.469-.257,1.046-.392,1.72s-.31,1.438-.448,2.294c-.318,1.7-.6,3.748-.843,6.026-.221,2.28-.381,4.8-.424,7.44s.064,5.162.217,7.447c.173,2.284.392,4.336.646,6.049.11.859.25,1.63.363,2.309s.221,1.26.321,1.734c.094.45.171.812.229,1.091a1.91,1.91,0,0,0,.1.376",
    transform: "translate(-160.772 -76.75)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90960",
    "data-name": "Path 90960",
    d: "M463.786,284.035a3.409,3.409,0,0,0,1.127.188,11.849,11.849,0,0,0,5.4-.921,3.418,3.418,0,0,0,1-.551,18.537,18.537,0,0,1-7.528,1.284",
    transform: "translate(-160.129 -97.622)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90961",
    "data-name": "Path 90961",
    d: "M517.13,254.045s7.18,9.634,6.684,20.622c-.73,16.194-4,18.386-6.333,32.926-1.884,11.725-2.593,33.2-3.9,40.187S507.49,372.8,507.49,372.8l-10.484.648s-.031-47.9-.031-53.6.236-33.535.236-33.535l-14.692,45.141L475.6,374.6l-12.181-.55s1.67-36.67,2.294-43.507c.923-10.113,5.124-47.248,7.092-53.752s9.642-22.8,9.642-22.8Z",
    transform: "translate(-160.003 -87.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90962",
    "data-name": "Path 90962",
    d: "M457.854,423.737l-.273,12s-12.041,4.488-12.173,6.713l23.289-.041.062-18.718Z",
    transform: "translate(-153.784 -146.285)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90963",
    "data-name": "Path 90963",
    d: "M474.4,440.507a.95.95,0,0,1,.659,1.084.914.914,0,0,1-1.069.663,1,1,0,0,1-.693-1.152.948.948,0,0,1,1.188-.566",
    transform: "translate(-163.401 -152.079)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90964",
    "data-name": "Path 90964",
    d: "M468.691,451.284l-.067-1.887-22.3.745s-1.036.452-.917,1.182Z",
    transform: "translate(-153.779 -155.161)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90965",
    "data-name": "Path 90965",
    d: "M463.422,441.853c0,.114.573.164,1.133.529.57.35.859.842.964.8.1-.022-.066-.7-.752-1.131s-1.369-.3-1.344-.194",
    transform: "translate(-160.003 -152.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90966",
    "data-name": "Path 90966",
    d: "M459.694,443.434c-.026.11.467.3.854.783s.5.989.613.983c.107.018.184-.648-.308-1.236s-1.157-.638-1.159-.53",
    transform: "translate(-158.716 -153.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90967",
    "data-name": "Path 90967",
    d: "M457.1,446.893c.1.024.261-.545-.033-1.167s-.825-.87-.873-.775c-.064.094.282.428.514.942s.278.988.392,1",
    transform: "translate(-157.506 -153.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90968",
    "data-name": "Path 90968",
    d: "M463.726,437.5c.048.1.569-.054,1.212-.012s1.144.244,1.2.147c.066-.083-.423-.5-1.181-.542s-1.29.318-1.234.407",
    transform: "translate(-160.107 -150.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90969",
    "data-name": "Path 90969",
    d: "M525.175,421.578l-.33,14.519,3.05,11.559a1.488,1.488,0,0,1-2.465,1.457c-2.216-2.125-10.331-9.983-10.248-11.044.1-1.229-.668-15.338-.668-15.338Z",
    transform: "translate(-177.644 -145.556)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90970",
    "data-name": "Path 90970",
    d: "M527.09,457.675l-11.555-12.408v.615a2.238,2.238,0,0,0,.531,1.452c.922,1.083,3.534,4.019,9.672,9.957a1.489,1.489,0,0,0,1.351.383",
    transform: "translate(-177.997 -153.735)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44367",
    "data-name": "Group 44367",
    transform: "translate(339.208 286.705)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44366",
    "data-name": "Group 44366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44365",
    "data-name": "Group 44365",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90971",
    "data-name": "Path 90971",
    d: "M519.4,438.038a.9.9,0,0,1,.247,1.176.866.866,0,0,1-1.163.255.95.95,0,0,1-.255-1.247.9.9,0,0,1,1.239-.131",
    transform: "translate(-518.085 -437.896)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_90972",
    "data-name": "Path 90972",
    d: "M528.105,453.651a3.212,3.212,0,0,1,2.945-1.45c.012-.036-.171-.149-.511-.2a2.371,2.371,0,0,0-2.279,1.121c-.169.3-.192.513-.156.525",
    transform: "translate(-182.332 -156.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90973",
    "data-name": "Path 90973",
    d: "M529.688,456.954a4.442,4.442,0,0,1,2.7-.808,1.653,1.653,0,0,0-1.51-.122c-.855.251-1.27.891-1.195.93",
    transform: "translate(-182.88 -157.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90974",
    "data-name": "Path 90974",
    d: "M525.169,449.821a7.648,7.648,0,0,1,4.074-1.6,4.07,4.07,0,0,0-4.074,1.6",
    transform: "translate(-181.321 -154.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90975",
    "data-name": "Path 90975",
    d: "M524.76,443.647c.039.087.841-.248,1.885-.286s1.871.213,1.9.122a3.693,3.693,0,0,0-3.788.164",
    transform: "translate(-181.181 -152.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90976",
    "data-name": "Path 90976",
    d: "M524.744,437.1a4.726,4.726,0,0,1,3.879.133c.024-.03-.135-.212-.469-.406a3.247,3.247,0,0,0-2.914-.1c-.348.17-.519.341-.5.373",
    transform: "translate(-181.175 -150.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90977",
    "data-name": "Path 90977",
    d: "M526.611,434.18a1.259,1.259,0,0,0,.02-.549,3.811,3.811,0,0,0-.437-1.438,1.7,1.7,0,0,0-.726-.808.6.6,0,0,0-.674.133.976.976,0,0,0-.23.656,2.1,2.1,0,0,0,1.844,1.945,2.437,2.437,0,0,0,2.4-1.276.845.845,0,0,0,.04-.7.585.585,0,0,0-.613-.31,2.071,2.071,0,0,0-.957.5,4.248,4.248,0,0,0-.991,1.129,1.311,1.311,0,0,0-.223.5,6.793,6.793,0,0,1,1.351-1.451,1.945,1.945,0,0,1,.845-.413.312.312,0,0,1,.335.167.58.58,0,0,1-.053.462,2.179,2.179,0,0,1-2.09,1.082,1.826,1.826,0,0,1-1.589-1.629.706.706,0,0,1,.141-.465.324.324,0,0,1,.371-.079,1.534,1.534,0,0,1,.627.672,5.662,5.662,0,0,1,.613,1.878",
    transform: "translate(-181.114 -148.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90978",
    "data-name": "Path 90978",
    d: "M533.963,191.957s-3.56-4.321-5.908-5.778-11.842-5.42-11.842-5.42-2.015,3.807-6.079,3.807a6.785,6.785,0,0,1-5.634-3.229L490.1,182.7s-1.942,26.866-1.133,30.184,1,17.54,1,17.54L524.3,228.3l1.539-27.615Z",
    transform: "translate(-168.756 -62.41)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90979",
    "data-name": "Path 90979",
    d: "M524.842,234.349c.161-.335.732-30.7-2.912-30.564s-27.587-2.608-28,1-5.155,39.93-5.155,39.93l22.2,12.721,16.867-14.183",
    transform: "translate(-168.757 -70.059)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90980",
    "data-name": "Path 90980",
    d: "M498.73,182.313a7.57,7.57,0,0,1,5.375-.334s.586,12.72-.511,14.235-4.6.4-4.6.4Z",
    transform: "translate(-172.194 -62.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90981",
    "data-name": "Path 90981",
    d: "M533.671,183.965a7.574,7.574,0,0,1,5.349.621s-1.672,12.623-3.02,13.921-4.6-.416-4.6-.416Z",
    transform: "translate(-183.474 -63.435)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90982",
    "data-name": "Path 90982",
    d: "M506.445,222.515a.575.575,0,0,0-.014.152c0,.118-.006.265-.01.445,0,.416,0,.987-.007,1.711.007,1.512.018,3.654.031,6.291q0,.5.008,1.019a1.469,1.469,0,0,0,.323,1.07,1.33,1.33,0,0,0,.484.352,2.135,2.135,0,0,0,.577.122l1.144.141c1.554.181,3.219.32,4.975.421s3.6.155,5.514.156l1.448-.009.733-.012a2.046,2.046,0,0,0,.78-.1,1.369,1.369,0,0,0,.634-.527,1.638,1.638,0,0,0,.229-.775q.088-.744.177-1.5c.237-2.013.468-3.978.691-5.876a10.348,10.348,0,0,0,.133-2.845,2.409,2.409,0,0,0-.681-1.254,3.578,3.578,0,0,0-1.165-.739,11.494,11.494,0,0,0-2.523-.6c-.824-.131-1.627-.234-2.406-.32-1.556-.171-3.013-.255-4.344-.282s-2.534,0-3.59.056a3.914,3.914,0,0,0-2.6.7,1.8,1.8,0,0,0-.479.881,3.466,3.466,0,0,0-.086.725c0,.2,0,.346.007.447a.56.56,0,0,0,.017.151c.013,0,.012-.206.038-.594a2.248,2.248,0,0,1,.585-1.523,3.842,3.842,0,0,1,2.527-.615c1.052-.039,2.252-.052,3.577-.009s2.774.137,4.321.318c.774.09,1.572.2,2.391.333a11.329,11.329,0,0,1,2.457.591,2.524,2.524,0,0,1,1.668,1.791,10.281,10.281,0,0,1-.145,2.752c-.225,1.9-.458,3.863-.7,5.876q-.089.754-.177,1.5a1.33,1.33,0,0,1-.181.646,1.065,1.065,0,0,1-.49.408,1.781,1.781,0,0,1-.672.082l-.73.014-1.444.012c-1.908,0-3.748-.048-5.5-.138s-3.413-.222-4.962-.392l-1.141-.132a1.874,1.874,0,0,1-.516-.1,1.089,1.089,0,0,1-.4-.284,1.233,1.233,0,0,1-.275-.917q-.01-.522-.018-1.019c-.054-2.637-.1-4.779-.128-6.29-.022-.723-.039-1.3-.05-1.71-.009-.18-.016-.326-.021-.445a.571.571,0,0,0-.018-.151",
    transform: "translate(-174.847 -75.801)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90983",
    "data-name": "Path 90983",
    d: "M531.554,203.274a1.434,1.434,0,0,0-.145.46,8.056,8.056,0,0,0-.206,1.3,4.052,4.052,0,0,0,.308,1.951,2.383,2.383,0,0,0,1.916,1.455,1.787,1.787,0,0,0,1.258-.352,2.934,2.934,0,0,0,.763-.918,10.245,10.245,0,0,0,.76-1.8,9.182,9.182,0,0,0,.31-1.276,1.3,1.3,0,0,0,.037-.481c-.048-.01-.175.662-.553,1.687a11.74,11.74,0,0,1-.8,1.73,2.719,2.719,0,0,1-.7.819,1.5,1.5,0,0,1-1.051.287,2.125,2.125,0,0,1-1.689-1.27,4.044,4.044,0,0,1-.347-1.823c.042-1.084.192-1.761.134-1.768",
    transform: "translate(-183.402 -70.184)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90984",
    "data-name": "Path 90984",
    d: "M499.062,202.856a1.253,1.253,0,0,0-.106.44,6.691,6.691,0,0,0-.09,1.231,3.308,3.308,0,0,0,.53,1.78,2.3,2.3,0,0,0,2.021,1.023,1.929,1.929,0,0,0,1.144-.435,2.8,2.8,0,0,0,.679-.892,8.9,8.9,0,0,0,.615-1.73,4.8,4.8,0,0,0,.2-1.667c-.049-.006-.12.631-.414,1.61a10.234,10.234,0,0,1-.657,1.656,2.57,2.57,0,0,1-.619.79,1.644,1.644,0,0,1-.968.361,2.053,2.053,0,0,1-1.774-.879,3.236,3.236,0,0,1-.545-1.63c-.058-1.01.039-1.656-.02-1.658",
    transform: "translate(-172.241 -69.953)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90985",
    "data-name": "Path 90985",
    d: "M534.1,205.039a.783.783,0,1,0,.837.725.814.814,0,0,0-.837-.725",
    transform: "translate(-184.156 -70.792)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90986",
    "data-name": "Path 90986",
    d: "M502.136,203.073a.783.783,0,1,0,.837.725.813.813,0,0,0-.837-.725",
    transform: "translate(-173.119 -70.114)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90987",
    "data-name": "Path 90987",
    d: "M523.639,204.411l-.787,38.658h-27.1l.025-38.729Z",
    transform: "translate(-171.166 -70.552)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90988",
    "data-name": "Path 90988",
    d: "M496.651,219.739a4.554,4.554,0,0,0,.829-.158l.966-.228a8.8,8.8,0,0,0,1.255-.39,18.9,18.9,0,0,0,6.591-3.749l.821-.739c.262-.251.5-.522.741-.776a18.5,18.5,0,0,0,3.1-4.47,14.939,14.939,0,0,0,.89-2.129,3.093,3.093,0,0,0,.206-.821c-.023-.006-.11.281-.315.782a19.107,19.107,0,0,1-.968,2.072,21.6,21.6,0,0,1-1.827,2.849c-.41.486-.8,1.031-1.3,1.518-.241.249-.475.515-.733.761l-.811.727a19.9,19.9,0,0,1-6.466,3.776,9.353,9.353,0,0,1-1.231.428l-.947.276a4.582,4.582,0,0,0-.8.271",
    transform: "translate(-171.477 -71.221)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90989",
    "data-name": "Path 90989",
    d: "M529.448,218.757l-.635,27.33h-22.3l.934-27.628Z",
    transform: "translate(-174.882 -75.426)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90990",
    "data-name": "Path 90990",
    d: "M537.982,246.633a.912.912,0,0,0,.031-.267c.009-.21.02-.463.032-.766.022-.714.052-1.664.088-2.817.094-2.423.222-5.686.363-9.291.151-3.63.256-6.919.276-9.3.011-1.191.008-2.155-.008-2.821-.009-.3-.017-.557-.024-.767a.92.92,0,0,0-.029-.267.9.9,0,0,0-.031.267c-.009.21-.02.462-.032.766-.022.713-.052,1.664-.088,2.817-.094,2.423-.222,5.686-.363,9.293-.151,3.629-.256,6.917-.276,9.3-.011,1.19-.008,2.154.007,2.821.01.3.018.557.024.767a.923.923,0,0,0,.029.267",
    transform: "translate(-185.723 -76.075)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18537",
    "data-name": "Rectangle 18537",
    width: 11.026,
    height: 3.697,
    transform: "translate(337.792 147.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90991",
    "data-name": "Path 90991",
    d: "M477.388,198.161c-.234-.052-4.629,23.686-4.629,27.565s.479,8.588,5.108,9.705,34.179-1.473,34.179-1.473l-9.917-6.428-5.864-.5-14.094-2.121,2.64-19.563s-4.549-6.544-7.422-7.182",
    transform: "translate(-163.228 -68.418)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90992",
    "data-name": "Path 90992",
    d: "M481.481,242.353a6.571,6.571,0,0,0,.308-.772,4.117,4.117,0,0,1,2.96-2.329,6.374,6.374,0,0,0,.823-.119,1.513,1.513,0,0,0-.851-.09,3.745,3.745,0,0,0-3.128,2.46,1.518,1.518,0,0,0-.112.849",
    transform: "translate(-166.231 -82.53)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90993",
    "data-name": "Path 90993",
    d: "M488.705,183.3a11.542,11.542,0,0,0-7.038,2.478c-2.873,2.545-3.911,8.982-3.911,8.982l9.1,6.571Z",
    transform: "translate(-164.953 -63.286)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90994",
    "data-name": "Path 90994",
    d: "M556.635,202.114l-11.993,3.828,2.7-16.9a16.05,16.05,0,0,1,9.291,13.076",
    transform: "translate(-188.046 -65.268)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90995",
    "data-name": "Path 90995",
    d: "M547.857,200.411a7.648,7.648,0,0,0-.508,1.376l-1.112,3.349-1.161,3.333a7.6,7.6,0,0,0-.436,1.4,6.773,6.773,0,0,0,.633-1.325c.35-.835.8-2,1.247-3.312s.8-2.51,1.031-3.385a6.761,6.761,0,0,0,.306-1.436",
    transform: "translate(-188.043 -69.195)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90996",
    "data-name": "Path 90996",
    d: "M494.545,182.635l-5.61,37.088-1.8-.31,2.379-36.477s4.539-1.315,5.034-.3",
    transform: "translate(-168.19 -62.925)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90997",
    "data-name": "Path 90997",
    d: "M503.813,222.066l26.341,4.821.485-14.151,10.893-3.336c.7,6.508-.649,27.031-3.376,28.438s-10.641,1.407-15.39,0-18.479-8.254-18.479-8.254Z",
    transform: "translate(-173.949 -72.299)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90998",
    "data-name": "Path 90998",
    d: "M501.07,226.121l-3.173-1.143a23.1,23.1,0,0,0-2.456-3.242c-1.13-1.13-7.875-3.9-7.875-3.9s-1.679.2-.413,1.776a10.285,10.285,0,0,0,2.294,2.206s-1.818.166-2.161.657-.1,2.211.049,2.751a4.165,4.165,0,0,0,0,2.9l.049.442a2.605,2.605,0,0,0,1.032,2.211s-.488,1.005.788,1.436,9.284.283,9.284.283Z",
    transform: "translate(-168.034 -75.21)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90999",
    "data-name": "Path 90999",
    d: "M498.411,232.418a.791.791,0,0,0-.208-.018l-.6-.012-2.283-.025c-.981-.014-2.17-.029-3.527-.084-.676-.033-1.4-.064-2.142-.166a1.833,1.833,0,0,1-1-.39.829.829,0,0,1-.183-.966l.04-.091-.07-.065a3.466,3.466,0,0,1-.727-.934,2.113,2.113,0,0,1-.256-1.154l0-.027,0-.014c-.015-.137-.031-.289-.048-.442l0-.018-.007-.018a4.024,4.024,0,0,1,0-2.789l.018-.05-.012-.047a8.177,8.177,0,0,1-.211-1.543,3.669,3.669,0,0,1,.037-.78.767.767,0,0,1,.118-.316.8.8,0,0,1,.282-.193,6.421,6.421,0,0,1,1.759-.39l.4-.046-.336-.228a10.7,10.7,0,0,1-2.064-1.934,2.346,2.346,0,0,1-.636-1.107c-.05-.384.374-.621.758-.678l-.069-.009c1.742.72,3.346,1.419,4.755,2.084.7.335,1.361.659,1.954.987a4.889,4.889,0,0,1,1.473,1.1,23.3,23.3,0,0,1,1.64,2.079l.411.576a1.024,1.024,0,0,0,.151.193.939.939,0,0,0-.113-.218c-.081-.139-.206-.342-.375-.6a19.441,19.441,0,0,0-1.588-2.141,5.024,5.024,0,0,0-1.5-1.163c-.594-.34-1.251-.675-1.953-1.019-1.408-.684-3.007-1.4-4.751-2.131l-.036-.015-.033.005a1.5,1.5,0,0,0-.68.267.8.8,0,0,0-.329.707,2.562,2.562,0,0,0,.7,1.272,10.806,10.806,0,0,0,2.131,2l.064-.274a6.625,6.625,0,0,0-1.857.415,1.067,1.067,0,0,0-.392.28,1.048,1.048,0,0,0-.175.445,3.921,3.921,0,0,0-.041.848,8.384,8.384,0,0,0,.225,1.607l.007-.1a4.294,4.294,0,0,0,0,3.008l-.009-.035c.018.153.035.305.05.442l0-.041a2.923,2.923,0,0,0,1.08,2.333l-.029-.156a1.093,1.093,0,0,0,.251,1.272,2.061,2.061,0,0,0,1.14.443c.767.1,1.489.119,2.17.143,1.362.037,2.552.031,3.535.022s1.756-.03,2.284-.05l.6-.028a.779.779,0,0,0,.207-.025",
    transform: "translate(-167.958 -75.135)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91000",
    "data-name": "Path 91000",
    d: "M546.717,241.357a1.876,1.876,0,0,0,.1-.9,5.124,5.124,0,0,0-1.961-3.787,1.865,1.865,0,0,0-.792-.431,6.507,6.507,0,0,1,2.648,5.115",
    transform: "translate(-187.848 -81.565)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91001",
    "data-name": "Path 91001",
    d: "M504.768,240.31a6.142,6.142,0,0,0,.845.508c.552.312,1.362.742,2.374,1.256,2.021,1.027,4.863,2.355,8.08,3.634s6.2,2.261,8.373,2.9c1.087.321,1.972.564,2.588.716a6.211,6.211,0,0,0,.962.21,6.243,6.243,0,0,0-.931-.322l-2.557-.8c-2.156-.69-5.115-1.7-8.326-2.978s-6.056-2.569-8.1-3.546l-2.413-1.169a6.175,6.175,0,0,0-.9-.405",
    transform: "translate(-174.279 -82.97)",
    fill: "#6f4439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44374",
    "data-name": "Group 44374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44373",
    "data-name": "Group 44373",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91002",
    "data-name": "Path 91002",
    d: "M312.636,332.656l-2.244-.24a6.434,6.434,0,0,1-5.6-7.79l7.2-32.477,11.322,1.211-3.593,33.583a6.435,6.435,0,0,1-7.083,5.714",
    transform: "translate(-105.182 -100.869)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91003",
    "data-name": "Path 91003",
    d: "M377.621,166.916a3.45,3.45,0,0,0-1.906-1.819,22.526,22.526,0,0,0-7.531-1.948,63.3,63.3,0,0,0-16.175.19,24.144,24.144,0,0,0-6.918,1.829,5.359,5.359,0,0,0-1.915,1.343,2.39,2.39,0,0,0-.529,2.2,1.56,1.56,0,0,0,1.844,1.053l29.587,1.169a7.8,7.8,0,0,0,2.629-1.353,2.652,2.652,0,0,0,.913-2.661",
    transform: "translate(-118.273 -56.182)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91004",
    "data-name": "Path 91004",
    d: "M346.54,117.967a4.492,4.492,0,0,0-1.445,3.59c.019.2.1.445.3.469a.483.483,0,0,0,.277-.082l5.411-2.885",
    transform: "translate(-119.143 -40.73)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91005",
    "data-name": "Path 91005",
    d: "M377.487,137.556a47.1,47.1,0,0,0,2.045-7.861,16.447,16.447,0,0,0-.648-8.022c-.143-.386-1.364-2.969-1.774-2.929-.293.029.461,2.44.313,2.694a13.941,13.941,0,0,0-1.565,8.13,36.674,36.674,0,0,0,1.629,7.988",
    transform: "translate(-129.75 -40.998)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91006",
    "data-name": "Path 91006",
    d: "M366.626,150.025l.213-25c.218-6.8-3.555-12.587-10.354-12.617l-.629.033a12.155,12.155,0,0,0-11.5,11.813c-.156,5.891-.253,12.4-.045,15.547.432,6.51,7,7.172,7,7.172s.1,6.634.124,8.549l9.818-.671,2.346-.249Z",
    transform: "translate(-118.839 -38.811)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91007",
    "data-name": "Path 91007",
    d: "M355.072,163.637a15.762,15.762,0,0,0,8.347-2.965s-1.776,5.007-8.308,4.772Z",
    transform: "translate(-122.594 -55.475)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91008",
    "data-name": "Path 91008",
    d: "M349.176,139.376a.931.931,0,0,0,.948.89.891.891,0,0,0,.913-.89.932.932,0,0,0-.947-.89.892.892,0,0,0-.915.891",
    transform: "translate(-120.558 -47.814)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91009",
    "data-name": "Path 91009",
    d: "M346.789,134.212c.122.115.8-.445,1.8-.5s1.762.41,1.863.282c.05-.057-.079-.27-.411-.486a2.559,2.559,0,0,0-1.5-.375,2.458,2.458,0,0,0-1.425.547c-.295.253-.387.477-.327.529",
    transform: "translate(-119.728 -45.966)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91010",
    "data-name": "Path 91010",
    d: "M362.561,138.023a.932.932,0,0,0,.948.89.891.891,0,0,0,.913-.891.932.932,0,0,0-.947-.89.892.892,0,0,0-.915.891",
    transform: "translate(-125.18 -47.347)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91011",
    "data-name": "Path 91011",
    d: "M361.8,133.757c.122.115.8-.445,1.8-.5,1-.066,1.762.409,1.864.281.05-.057-.078-.27-.412-.485a2.552,2.552,0,0,0-1.5-.376,2.454,2.454,0,0,0-1.424.547c-.295.253-.388.478-.328.529",
    transform: "translate(-124.91 -45.809)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91012",
    "data-name": "Path 91012",
    d: "M355.589,141.96a6.662,6.662,0,0,0-1.642-.206c-.257-.012-.5-.05-.554-.223a1.3,1.3,0,0,1,.13-.767l.651-1.988a33.558,33.558,0,0,0,1.423-5.183,33.479,33.479,0,0,0-1.837,5.057c-.215.7-.422,1.361-.618,2a1.48,1.48,0,0,0-.079,1.01.643.643,0,0,0,.44.351,1.732,1.732,0,0,0,.438.037,6.529,6.529,0,0,0,1.648-.086",
    transform: "translate(-121.878 -46.126)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91013",
    "data-name": "Path 91013",
    d: "M361.046,128.943c.15.248,1.107-.073,2.288-.162,1.18-.113,2.178.041,2.283-.229.045-.128-.166-.348-.594-.532a3.987,3.987,0,0,0-3.483.3c-.39.254-.561.507-.494.625",
    transform: "translate(-124.652 -44.108)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91014",
    "data-name": "Path 91014",
    d: "M346.147,130.074c.217.22,1.023-.048,2-.1.979-.079,1.818.082,2-.163.079-.119-.06-.342-.431-.543a3.146,3.146,0,0,0-1.644-.309,3.109,3.109,0,0,0-1.582.519c-.337.247-.442.486-.346.593",
    transform: "translate(-119.501 -44.523)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91015",
    "data-name": "Path 91015",
    d: "M378.365,138.938c.109-.054,4.4-1.565,4.5,2.9s-4.4,3.64-4.412,3.512-.091-6.408-.091-6.408",
    transform: "translate(-130.636 -47.871)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91016",
    "data-name": "Path 91016",
    d: "M380.527,144.379c.019-.015.079.052.211.11a.781.781,0,0,0,.581,0,1.924,1.924,0,0,0,.852-1.746,2.56,2.56,0,0,0-.242-1.108.9.9,0,0,0-.6-.583.4.4,0,0,0-.454.223c-.057.126-.027.214-.05.223s-.1-.073-.065-.258a.5.5,0,0,1,.17-.283.586.586,0,0,1,.427-.123,1.094,1.094,0,0,1,.828.674,2.646,2.646,0,0,1,.3,1.238,2.017,2.017,0,0,1-1.091,1.951.831.831,0,0,1-.713-.1c-.141-.107-.166-.206-.151-.215",
    transform: "translate(-131.382 -48.624)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91017",
    "data-name": "Path 91017",
    d: "M348.629,116.4c-.727-.389,1.409-2.756,3.173-3.585,2.666-1.253,6.752-2.056,9.234-1.387a10.752,10.752,0,0,1,7.012,4.944,17.549,17.549,0,0,1,2.088,8.935,5.327,5.327,0,0,1-.593,2.735c-.61.995-1.495,1.494-1.727,2.991a2.471,2.471,0,0,1-.446,1.368c-.8.879-1.814.077-2.284-.735a12.92,12.92,0,0,1-1.253-5.821,13.058,13.058,0,0,1,.226-4.247c.209-.746.55-1.454.717-2.211a2.679,2.679,0,0,0-.346-2.223,2.792,2.792,0,0,0-.367-.362,4.654,4.654,0,0,0-4.628-.818c-2.5.923-6.775,2.307-7.907,1.469a6.873,6.873,0,0,1-2.025-2Z",
    transform: "translate(-120.319 -38.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91018",
    "data-name": "Path 91018",
    d: "M360.2,147.259c-.154-.008-.147,1.017-1.018,1.751s-1.963.631-1.97.774c-.014.065.245.2.706.206a2.55,2.55,0,0,0,1.645-.588,2.224,2.224,0,0,0,.788-1.468c.036-.429-.081-.682-.151-.675",
    transform: "translate(-123.331 -50.843)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91019",
    "data-name": "Path 91019",
    d: "M370.079,127.781c.083-.077.21-.095.288-.172,5.2-5.087.952-9.858.864-11.344-.122-2.06,2.371.515,2.653-2.2.373-3.6-3.483-5.087-8.223-6.571-1.986-.621-6.837-.754-11.078.2a12.95,12.95,0,0,0-7.685,5.667,3.216,3.216,0,0,0-1.087.839c-.649,1.245-.34,1.748-.34,1.748s8.325-4.469,15.428,1.162,5.9,10.583,7.756,10.619Z",
    transform: "translate(-119.254 -36.943)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91020",
    "data-name": "Path 91020",
    d: "M374.045,112.453a2.416,2.416,0,0,0,.372.152c.121.043.269.1.436.172s.363.145.568.249a12.671,12.671,0,0,1,1.414.777,13.589,13.589,0,0,1,1.576,1.188,13.736,13.736,0,0,1,1.368,1.421,12.448,12.448,0,0,1,.94,1.311c.128.191.225.376.317.534s.166.3.223.412a2.465,2.465,0,0,0,.2.351,2.306,2.306,0,0,0-.149-.373c-.051-.119-.117-.263-.2-.424s-.178-.352-.3-.547a11.46,11.46,0,0,0-.926-1.338A11.831,11.831,0,0,0,376.9,113.7a11.419,11.419,0,0,0-1.44-.759c-.209-.1-.408-.168-.579-.234a4.615,4.615,0,0,0-.446-.153,2.364,2.364,0,0,0-.388-.1",
    transform: "translate(-129.145 -38.826)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91021",
    "data-name": "Path 91021",
    d: "M347.346,115.972a.394.394,0,0,0,.078-.029l.223-.095c.194-.088.486-.208.861-.36s.843-.318,1.395-.481a15.033,15.033,0,0,1,1.9-.45,15.248,15.248,0,0,1,5.053-.01,15.669,15.669,0,0,1,5.781,2.165,15.084,15.084,0,0,1,2.526,1.981,15.766,15.766,0,0,1,1.918,2.3A21.923,21.923,0,0,1,369.4,125.5c.52,1.352.854,2.478,1.08,3.256.108.384.193.686.253.9l.067.234a.329.329,0,0,0,.027.078.4.4,0,0,0-.014-.081l-.055-.237c-.048-.208-.124-.514-.23-.905-.212-.783-.532-1.915-1.043-3.276a21.648,21.648,0,0,0-2.311-4.541,15.868,15.868,0,0,0-1.928-2.32,15.068,15.068,0,0,0-2.546-2,15.675,15.675,0,0,0-5.831-2.173,15.164,15.164,0,0,0-5.089.039,14.71,14.71,0,0,0-1.9.47c-.553.17-1.015.353-1.392.5s-.662.286-.853.382l-.218.107a.41.41,0,0,0-.073.041",
    transform: "translate(-119.927 -39.441)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91022",
    "data-name": "Path 91022",
    d: "M378.667,134.961a2.445,2.445,0,0,0,2.18-.888,4.1,4.1,0,0,1-2.18.888",
    transform: "translate(-130.741 -46.29)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91023",
    "data-name": "Path 91023",
    d: "M375,128.406a1.22,1.22,0,0,0,.457-.108,3.476,3.476,0,0,0,1.733-1.419,1.216,1.216,0,0,0,.2-.427A4.658,4.658,0,0,1,375,128.406",
    transform: "translate(-129.474 -43.659)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91024",
    "data-name": "Path 91024",
    d: "M368.722,120.872a6.685,6.685,0,0,1,1.88-2.278,3.845,3.845,0,0,0-1.88,2.278",
    transform: "translate(-127.306 -40.946)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91025",
    "data-name": "Path 91025",
    d: "M362.5,117.748a6.622,6.622,0,0,1,1.038-2.493,3.532,3.532,0,0,0-1.038,2.493",
    transform: "translate(-125.154 -39.793)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91026",
    "data-name": "Path 91026",
    d: "M353.117,117.249a2.963,2.963,0,0,1,.655-2.535c-.01-.011-.141.078-.3.274a2.336,2.336,0,0,0-.443.885,2.313,2.313,0,0,0-.04.989.869.869,0,0,0,.133.388",
    transform: "translate(-121.861 -39.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91027",
    "data-name": "Path 91027",
    d: "M347.467,118.9a8.329,8.329,0,0,1-.128-1.047,8.585,8.585,0,0,1,.134-1.047,2.238,2.238,0,0,0-.005,2.094",
    transform: "translate(-119.88 -40.331)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91028",
    "data-name": "Path 91028",
    d: "M343,112.668a3.816,3.816,0,0,1,4.293-1.086,5.36,5.36,0,0,1,3.058,3.42,2.325,2.325,0,0,1,2.91.815l1.916.348a7.833,7.833,0,0,1-.913,2.25,2.645,2.645,0,0,1-1.99,1.249,1.621,1.621,0,0,1-1.7-1.4,3.943,3.943,0,0,1-3.374,2.272,4.1,4.1,0,0,1-3.175-.719,2.19,2.19,0,0,1-.415-2.979,2.98,2.98,0,0,1-.612-4.175",
    transform: "translate(-118.223 -38.44)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91029",
    "data-name": "Path 91029",
    d: "M330.294,289.014s-1.656,44.28-1.655,47.049c0,3.2-.22,11.8-.155,15.64s1.81,23.9,1.81,23.9l.519,7.082h12.8s4.136-46.328,4.427-50.165,5.527-40.427,5.818-39.541,5.909,36.591,6.155,40.427,0,49.279,0,49.279h14.3s2.7-28.842,3.539-42.188c.782-12.372,3.637-38.075,3.637-38.075V283.5l-28.508-2.913Z",
    transform: "translate(-113.41 -96.877)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91030",
    "data-name": "Path 91030",
    d: "M391.186,422.75l.334,12.534s12.6,4.64,12.744,6.964l-24.331.051-.141-19.556Z",
    transform: "translate(-131.13 -145.959)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91031",
    "data-name": "Path 91031",
    d: "M385.838,440.289a.994.994,0,0,0-.685,1.135.955.955,0,0,0,1.12.688,1.048,1.048,0,0,0,.719-1.206.991.991,0,0,0-1.244-.587",
    transform: "translate(-132.973 -152.002)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91032",
    "data-name": "Path 91032",
    d: "M380.008,451.571l.063-1.972,23.3.689s1.084.469.964,1.232Z",
    transform: "translate(-131.204 -155.231)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91033",
    "data-name": "Path 91033",
    d: "M397.138,441.648c0,.118-.6.174-1.181.557-.594.368-.894.883-1,.836-.109-.023.066-.733.781-1.185s1.429-.318,1.4-.208",
    transform: "translate(-136.354 -152.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91034",
    "data-name": "Path 91034",
    d: "M401.358,443.285c.027.115-.487.318-.889.822-.417.491-.518,1.035-.636,1.03-.111.019-.2-.676.317-1.293s1.206-.672,1.209-.558",
    transform: "translate(-138.02 -153.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91035",
    "data-name": "Path 91035",
    d: "M404.355,446.888c-.108.026-.274-.568.029-1.219s.858-.911.909-.813c.067.1-.292.447-.534.986s-.287,1.034-.4,1.046",
    transform: "translate(-139.56 -153.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91036",
    "data-name": "Path 91036",
    d: "M396.636,437.1c-.05.109-.6-.054-1.266-.007s-1.195.259-1.257.158c-.069-.086.441-.526,1.232-.571s1.349.327,1.291.42",
    transform: "translate(-136.071 -150.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91037",
    "data-name": "Path 91037",
    d: "M332.7,420.888l-.245,15.17L328.8,448a1.554,1.554,0,0,0,2.514,1.621c2.4-2.129,11.19-10,11.146-11.113-.051-1.288,1.321-15.985,1.321-15.985Z",
    transform: "translate(-113.499 -145.318)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91038",
    "data-name": "Path 91038",
    d: "M330.566,458.721l12.566-12.485-.026.643a2.341,2.341,0,0,1-.613,1.495c-1.007,1.093-3.852,4.053-10.5,10a1.553,1.553,0,0,1-1.426.345",
    transform: "translate(-114.133 -154.07)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44372",
    "data-name": "Group 44372",
    transform: "translate(225.663 287.024)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44371",
    "data-name": "Group 44371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44370",
    "data-name": "Group 44370",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91039",
    "data-name": "Path 91039",
    d: "M345.079,438.513a.94.94,0,0,0-.305,1.217.9.9,0,0,0,1.2.313.991.991,0,0,0,.316-1.291.938.938,0,0,0-1.288-.187",
    transform: "translate(-344.663 -438.383)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_91040",
    "data-name": "Path 91040",
    d: "M334.662,454.43c-.088.039-.4-.769-1.283-1.231a4.744,4.744,0,0,0-1.732-.4c-.012-.038.185-.148.541-.185a2.479,2.479,0,0,1,2.333,1.264c.164.318.179.543.141.554",
    transform: "translate(-114.506 -156.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91041",
    "data-name": "Path 91041",
    d: "M333.011,457.821c-.075.063-.542-.449-1.317-.7a12.537,12.537,0,0,0-1.473-.248,1.723,1.723,0,0,1,1.581-.067c.882.3,1.29.981,1.209,1.019",
    transform: "translate(-114.013 -157.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91042",
    "data-name": "Path 91042",
    d: "M337.269,450.525a7.979,7.979,0,0,0-4.188-1.836,4.249,4.249,0,0,1,4.188,1.836",
    transform: "translate(-115.001 -154.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91043",
    "data-name": "Path 91043",
    d: "M338.1,444.125c-.044.089-.868-.293-1.956-.375-1.087-.1-1.962.146-1.991.051a3.859,3.859,0,0,1,3.947.324",
    transform: "translate(-115.37 -153.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91044",
    "data-name": "Path 91044",
    d: "M338.322,437.3a4.94,4.94,0,0,0-4.055-.018c-.024-.033.149-.217.506-.4a3.387,3.387,0,0,1,3.046.014c.356.191.527.377.5.409",
    transform: "translate(-115.41 -150.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91045",
    "data-name": "Path 91045",
    d: "M402.464,175.707s8.861,2.425,11.9,14.317c1.46,5.707,1.154,19.791,1.405,22.208s.892,8.809,1.615,16.01c.137,1.363,1.933,2.368,2.054,3.832,0,0,1.318,4.347-.928,6.813-3.3,3.62.25,9.13.25,9.13l-1.22,3.276-6.119-1-.249-2.2s-3.541-10.146-5.243-17.929c-1.66-7.59-2.554-10.47-3.378-14.56a52.449,52.449,0,0,1-1-11.324Z",
    transform: "translate(-138.637 -60.666)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91046",
    "data-name": "Path 91046",
    d: "M316.952,278.208a4.479,4.479,0,0,0,1.268,2.634,10.691,10.691,0,0,1,1.723,3.623s.946,5.035,1.173,6.667.248,3.13-1.052,2.836-1.7-1.28-1.937-4.279l-.767-1.581-.7,1.218-.124,4.812s3.274,3.143,3.049,4.048-.845.759-.845.759l-.533.507-5.02-3.578-1.854-6.36.547-8.184v-6.371l5.352-.7Z",
    transform: "translate(-107.494 -94.692)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91047",
    "data-name": "Path 91047",
    d: "M329.042,174.49s-8.65.8-12.144,12.209c-1.677,5.476-2.019,19.17-2.371,21.505s-1.265,8.516-2.294,15.477C311.04,231.746,310,242.825,310,242.825l1.036,3.238,5.989-.7.342-2.127s3.9-9.695,5.9-17.176c1.956-7.3,2.955-10.053,3.941-13.988a50.975,50.975,0,0,0,1.484-10.952Z",
    transform: "translate(-107.032 -60.245)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91048",
    "data-name": "Path 91048",
    d: "M347.181,170.985l-13.131,2.978,2.614,43.944-5.986,33.416c.806,3.224,17.661,3.416,27.094,3.145,8.95-.257,23.674-3.983,24.714-5.648s-4.488-37.6-4.488-37.6V173.963l-14.485-3.305s-8.214,4.907-16.332.327",
    transform: "translate(-114.172 -58.922)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91049",
    "data-name": "Path 91049",
    d: "M330.092,245.11s24.549,1.336,30.724.908c9.752-.676,20.821-4.226,20.821-4.226v-3.4s4.317-3.513,1.3-5.354c-1.3-.79-1.247-4.38-1.659-6.751-1.456-8.39-2.063-23.685-2.063-23.685l-2.192-29.475-6.418-2.091-7.758-2.806-8.2,7.326s-6.791-5.829-9.407-7.326l-12.4,4.9-1.429,40.649s-1.02,8.053-1.712,13.5c-.369,2.906-1.858,5.154-1.858,7.452,0,2.912,2.912,5.584,2.912,5.584Z",
    transform: "translate(-113.192 -58.083)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91050",
    "data-name": "Path 91050",
    d: "M383,275.509a3.267,3.267,0,0,1-.5.115l-1.459.27c-1.267.234-3.109.526-5.391.84s-5.009.629-8.042.909c-3.035.263-6.378.484-9.892.612s-6.866.129-9.913.082c-3.046-.064-5.788-.173-8.087-.324s-4.158-.295-5.439-.429l-1.475-.156a3.31,3.31,0,0,1-.512-.075,3.159,3.159,0,0,1,.518.013l1.48.1c1.283.1,3.143.215,5.441.331s5.037.21,8.079.257c3.043.031,6.388.01,9.9-.106s6.846-.34,9.878-.587c3.03-.265,5.756-.548,8.038-.843s4.128-.545,5.4-.742l1.467-.213a3.279,3.279,0,0,1,.515-.054",
    transform: "translate(-114.727 -95.123)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91051",
    "data-name": "Path 91051",
    d: "M329.844,175.707c-.625.208-8.421,2.9-10.2,16.445a98.317,98.317,0,0,0-.431,16.967l13.753-1.146Z",
    transform: "translate(-110.15 -60.666)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91052",
    "data-name": "Path 91052",
    d: "M357.127,180.235a2.11,2.11,0,0,1-.582-.017,13.308,13.308,0,0,1-1.568-.234,18.841,18.841,0,0,1-9.18-4.793,13.407,13.407,0,0,1-1.088-1.152,2.1,2.1,0,0,1-.346-.468c.04-.036.589.581,1.583,1.46a21.2,21.2,0,0,0,9.079,4.741c1.289.312,2.11.411,2.1.464",
    transform: "translate(-118.896 -59.927)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91053",
    "data-name": "Path 91053",
    d: "M387.251,173.191a2.333,2.333,0,0,1-.437.428c-.292.263-.737.619-1.3,1.034A25.262,25.262,0,0,1,375.493,179c-.691.13-1.254.212-1.646.246a2.344,2.344,0,0,1-.611.027c-.007-.051.852-.173,2.212-.486a29.471,29.471,0,0,0,9.936-4.308c1.158-.779,1.834-1.323,1.867-1.283",
    transform: "translate(-128.866 -59.796)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91054",
    "data-name": "Path 91054",
    d: "M367.219,181.669c0-.01.067-.014.194-.01a2.861,2.861,0,0,1,.547.088,3.6,3.6,0,0,1,1.724,1.078,3.447,3.447,0,0,1,.706,1.244.812.812,0,0,1-.155.858.536.536,0,0,1-.5.115,1.331,1.331,0,0,1-.413-.2,5.447,5.447,0,0,1-2.2-2.952c-.05-.168-.09-.336-.124-.494l.3-.065a3.482,3.482,0,0,1-1.017,3.328,1.1,1.1,0,0,1-.817.278.738.738,0,0,1-.64-.53,1.108,1.108,0,0,1,.061-.748,3.3,3.3,0,0,1,.323-.566,5.218,5.218,0,0,1,1.348-1.358,2,2,0,0,1,.615-.329c.012.021-.2.147-.546.422a5.721,5.721,0,0,0-1.24,1.382,1.418,1.418,0,0,0-.323,1.122c.1.411.69.455,1.04.114a3.237,3.237,0,0,0,.9-3.043l.3-.065c.032.149.07.308.118.466a5.254,5.254,0,0,0,2.064,2.8c.221.162.45.251.579.123a.559.559,0,0,0,.09-.586,3.293,3.293,0,0,0-.627-1.172,3.68,3.68,0,0,0-1.594-1.105c-.443-.149-.708-.166-.706-.194",
    transform: "translate(-125.946 -62.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91055",
    "data-name": "Path 91055",
    d: "M329.86,191.772a2.173,2.173,0,0,1,.058.415c.027.3.063.7.107,1.2.088,1.038.2,2.542.313,4.4.235,3.718.483,8.861.616,14.546s.122,10.835.06,14.561c-.03,1.863-.068,3.37-.107,4.411-.022.5-.039.894-.052,1.2a2.158,2.158,0,0,1-.039.418,2.086,2.086,0,0,1-.023-.419c0-.3,0-.7-.007-1.2,0-1.077.006-2.574.01-4.411.006-3.724-.02-8.87-.151-14.552s-.346-10.82-.526-14.54c-.09-1.834-.162-3.331-.215-4.406l-.049-1.2a2.187,2.187,0,0,1,0-.42",
    transform: "translate(-113.887 -66.212)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91056",
    "data-name": "Path 91056",
    d: "M407.752,248.2a.641.641,0,0,1,.078-.155c.058-.1.146-.243.268-.429.244-.372.619-.909,1.133-1.577a4.481,4.481,0,0,0,.75-1.145,2.963,2.963,0,0,0,.1-1.59,4.608,4.608,0,0,0-.7-1.72l-1.115-1.82-.011-.018,0-.021c-.426-2.375-.849-5.149-1.211-8.2s-.655-6.391-.9-9.879c-.534-7.7-.71-14.68-.811-19.731-.033-2.506-.059-4.543-.078-5.983q0-1.03,0-1.627c0-.17.005-.31.007-.423a.51.51,0,0,1,.013-.145.536.536,0,0,1,.018.144c.006.113.014.252.023.422q.022.6.059,1.626c.042,1.439.1,3.475.175,5.98.157,5.049.367,12.026.9,19.715.244,3.484.537,6.816.878,9.868s.752,5.823,1.154,8.2l-.014-.039,1.1,1.832a4.761,4.761,0,0,1,.706,1.8,3.111,3.111,0,0,1-.137,1.679,4.509,4.509,0,0,1-.8,1.169c-.528.653-.918,1.176-1.178,1.534l-.295.409a.721.721,0,0,1-.107.136",
    transform: "translate(-139.919 -66.888)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91057",
    "data-name": "Path 91057",
    d: "M344.948,247.241a2.1,2.1,0,0,1,.042.577c.01.372,0,.91-.046,1.574a27.721,27.721,0,0,1-2.621,10.008c-.289.6-.541,1.075-.732,1.395a2.114,2.114,0,0,1-.319.482c-.044-.024.331-.753.854-1.966a33.663,33.663,0,0,0,2.6-9.938c.139-1.313.17-2.133.22-2.132",
    transform: "translate(-117.828 -85.364)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91058",
    "data-name": "Path 91058",
    d: "M396.179,258.53a2.64,2.64,0,0,1-.524-.386,14.831,14.831,0,0,1-1.3-1.206,20.4,20.4,0,0,1-5.345-10.255,14.891,14.891,0,0,1-.244-1.755,2.613,2.613,0,0,1-.016-.65c.055-.006.143.914.472,2.36a22.56,22.56,0,0,0,5.291,10.152c1,1.1,1.7,1.7,1.664,1.74",
    transform: "translate(-134.218 -84.341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91059",
    "data-name": "Path 91059",
    d: "M383.769,280.115,390.254,301l29.767-9.092-6.128-20.35-27.609,7.668-1.665.591Z",
    transform: "translate(-132.502 -93.761)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91060",
    "data-name": "Path 91060",
    d: "M385.067,283.831l6.261,19.7,2.009-.717L386.71,283.18Z",
    transform: "translate(-132.951 -97.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91061",
    "data-name": "Path 91061",
    d: "M389.724,283.612c.086-.029,1.672,4.515,3.541,10.147s3.315,10.224,3.228,10.253-1.671-4.514-3.541-10.148-3.315-10.222-3.229-10.251",
    transform: "translate(-134.557 -97.921)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91062",
    "data-name": "Path 91062",
    d: "M404.123,275.7a4.113,4.113,0,0,1-.784.284l-2.172.658c-1.838.541-4.383,1.267-7.2,2.049l-7.223,1.973-2.166.672a4.064,4.064,0,0,1-.809.2,4.015,4.015,0,0,1,.769-.326l2.137-.772c1.829-.573,4.382-1.277,7.2-2.066s5.374-1.474,7.229-1.958l2.2-.557a4.1,4.1,0,0,1,.819-.161",
    transform: "translate(-132.502 -95.189)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91063",
    "data-name": "Path 91063",
    d: "M405.441,301.059a63.459,63.459,0,0,1,3.735-6.676,14.8,14.8,0,0,1,4.267-3.345l7.139,3.376s-.2,8.379-.611,9.026a4.871,4.871,0,0,1-1.467,1.088,3.865,3.865,0,0,1-2.088.483l-.653-.034s-4.127,1.192-4.6.469c0,0-1.871,1.006-2.856.543a3.53,3.53,0,0,1-1.3-1.206l3.521-3.087.2-2.723a28.577,28.577,0,0,1-3.28,3.3c-1.019.68-2.552-.224-2-1.213",
    transform: "translate(-139.945 -100.485)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91064",
    "data-name": "Path 91064",
    d: "M413.605,274.658l2.7,9.877,7.139,3.376s-.278-6.747-.446-10.5c-.177-3.97-.314-5.212-.314-5.212s-5.409-.041-9.076,2.454",
    transform: "translate(-142.804 -93.983)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91065",
    "data-name": "Path 91065",
    d: "M417.314,308.305c.031-.039.251.26.056.721a1.883,1.883,0,0,1-.5.621c-.213.191-.452.391-.712.591a6.23,6.23,0,0,1-2.042,1.211,14.007,14.007,0,0,1,1.841-1.47,6.005,6.005,0,0,0,1.2-1.06,1.389,1.389,0,0,0,.152-.614",
    transform: "translate(-142.98 -106.446)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91066",
    "data-name": "Path 91066",
    d: "M328.326,177.346s.72-2.445,5.357-2.58c0,0-.064,12.06-.191,17.944-.426,19.865-4.447,61.093-4.447,61.093l-3.274-.857,2.671-33.725Z",
    transform: "translate(-112.478 -60.341)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44379",
    "data-name": "Group 44379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44378",
    "data-name": "Group 44378",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91067",
    "data-name": "Path 91067",
    d: "M217.75,263.176a18.088,18.088,0,0,1,9.081,15.1c.119,3.656.213,8.193.214,13.438,0,13.86,2.138,38.776,2.138,38.776l3.037,50.581-15.974,2.969L209.2,330.153l-4.044-25.793L203.59,329.6l.092,50.73-17.42.773-5.137-51.891-2.507-38.064,7.776-28.812,7.146-2.186,23.769,2.77Z",
    transform: "translate(-61.671 -89.822)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91068",
    "data-name": "Path 91068",
    d: "M212.178,270.875a.53.53,0,0,1,.029.155c.014.122.031.272.052.455q.06.644.164,1.753c.13,1.555.314,3.752.541,6.455.426,5.479,1.011,13,1.656,21.308l-.17-.158H217l-.17.177c-.323-7.77-.774-14.689-1.143-19.664-.188-2.465-.34-4.46-.447-5.872q-.074-1-.116-1.588a3.505,3.505,0,0,1-.019-.555,3.587,3.587,0,0,1,.084.548q.065.584.177,1.584c.145,1.378.339,3.378.552,5.864.43,4.973.921,11.894,1.252,19.669l.007.177h-2.882l-.012-.158c-.607-8.312-1.156-15.835-1.557-21.316-.181-2.706-.329-4.906-.433-6.462-.043-.741-.076-1.328-.1-1.759-.007-.184-.012-.335-.018-.458a.539.539,0,0,1,.006-.157",
    transform: "translate(-73.255 -93.524)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91069",
    "data-name": "Path 91069",
    d: "M250.646,431.428l.257,11.27s11.31,4.215,11.434,6.305l-21.875-.039-.059-17.582Z",
    transform: "translate(-83.003 -148.941)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91070",
    "data-name": "Path 91070",
    d: "M245.775,447.179a.893.893,0,0,0-.619,1.018.859.859,0,0,0,1,.623.943.943,0,0,0,.651-1.082.891.891,0,0,0-1.116-.532",
    transform: "translate(-84.638 -154.383)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91071",
    "data-name": "Path 91071",
    d: "M240.493,457.3l.064-1.772,20.95.7s.974.426.862,1.112Z",
    transform: "translate(-83.034 -157.279)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91072",
    "data-name": "Path 91072",
    d: "M255.929,448.443c0,.107-.538.155-1.064.5s-.807.791-.905.748c-.1-.021.062-.659.706-1.063s1.287-.281,1.263-.183",
    transform: "translate(-87.675 -154.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91073",
    "data-name": "Path 91073",
    d: "M259.718,449.928c.024.1-.439.284-.8.735s-.469.929-.576.924c-.1.017-.173-.609.29-1.161s1.086-.6,1.088-.5",
    transform: "translate(-89.17 -155.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91074",
    "data-name": "Path 91074",
    d: "M262.4,453.177c-.1.022-.245-.511.031-1.1s.775-.816.82-.727c.06.088-.264.4-.483.885s-.261.928-.367.939",
    transform: "translate(-90.554 -155.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91075",
    "data-name": "Path 91075",
    d: "M255.5,444.353c-.045.1-.535-.051-1.139-.011s-1.075.229-1.13.138.4-.472,1.109-.509,1.212.3,1.16.382",
    transform: "translate(-87.429 -153.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91076",
    "data-name": "Path 91076",
    d: "M192.326,429.4l.31,13.637-2.865,10.857a1.4,1.4,0,0,0,2.315,1.368c2.082-2,9.7-9.377,9.626-10.374-.091-1.154.628-14.407.628-14.407Z",
    transform: "translate(-65.505 -148.257)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91077",
    "data-name": "Path 91077",
    d: "M191.456,463.3l10.854-11.655v.578a2.1,2.1,0,0,1-.5,1.364c-.866,1.017-3.32,3.775-9.086,9.352a1.4,1.4,0,0,1-1.269.36",
    transform: "translate(-66.103 -155.939)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44377",
    "data-name": "Group 44377",
    transform: "translate(133.061 291.177)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44376",
    "data-name": "Group 44376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44375",
    "data-name": "Group 44375",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91078",
    "data-name": "Path 91078",
    d: "M203.575,444.859a.846.846,0,0,0-.232,1.1.813.813,0,0,0,1.093.239.892.892,0,0,0,.239-1.171.844.844,0,0,0-1.164-.123",
    transform: "translate(-203.229 -444.726)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_91079",
    "data-name": "Path 91079",
    d: "M194.76,459.524c-.077.038-.384-.677-1.2-1.061a4.265,4.265,0,0,0-1.57-.3c-.012-.033.161-.139.48-.185a2.229,2.229,0,0,1,2.14,1.053c.159.28.181.482.147.493",
    transform: "translate(-66.289 -158.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91080",
    "data-name": "Path 91080",
    d: "M193.394,462.627a11.308,11.308,0,0,0-1.208-.587,11.447,11.447,0,0,0-1.332-.172,1.552,1.552,0,0,1,1.418-.115c.8.235,1.193.837,1.122.874",
    transform: "translate(-65.895 -159.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91081",
    "data-name": "Path 91081",
    d: "M196.964,455.927a7.182,7.182,0,0,0-3.826-1.5,3.821,3.821,0,0,1,3.826,1.5",
    transform: "translate(-66.684 -156.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91082",
    "data-name": "Path 91082",
    d: "M197.49,450.127c-.036.082-.79-.233-1.77-.269s-1.758.2-1.787.116a3.467,3.467,0,0,1,3.558.153",
    transform: "translate(-66.958 -155.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91083",
    "data-name": "Path 91083",
    d: "M214.809,264.606a1.314,1.314,0,1,1-1.314-1.314,1.314,1.314,0,0,1,1.314,1.314",
    transform: "translate(-73.259 -90.906)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91084",
    "data-name": "Path 91084",
    d: "M191.123,153.288a131.361,131.361,0,0,1-2.488,18.571c-1.08,4.645-2.678,9.274-2.471,14.038a5.463,5.463,0,0,0,1.333,3.816,6.059,6.059,0,0,0,3.13,1.269c6.957,1.315,14.07,1.518,21.147,1.717l13.6.382c1.679.047,3.6-.01,4.683-1.3,1.324-1.58.563-3.953-.219-5.86a161.031,161.031,0,0,1-10.118-36.236",
    transform: "translate(-64.27 -51.683)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91085",
    "data-name": "Path 91085",
    d: "M195.992,140.963a16.01,16.01,0,0,1,11.8-7.249,17.177,17.177,0,0,1,6.084.548,8.894,8.894,0,0,1,5.347,2.89,14.909,14.909,0,0,1,3.509,6.52,21.383,21.383,0,0,1,.232,7.1,28.209,28.209,0,0,1-3.046,8.69l-4.26.907a40.894,40.894,0,0,1-10.742.376c-3.559-.506-7.113-2.079-9.252-4.968-2.972-4.013-2.481-10.686.325-14.817",
    transform: "translate(-66.861 -46.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91086",
    "data-name": "Path 91086",
    d: "M204.928,141.769l8.331-4.2,2.279.061c5.079-.435,9.08,4.852,9.479,8.961.445,4.565.806,10.156.381,13.588-.856,6.9-6.584,7.979-6.584,7.979s.959,8.048,1.206,10.318l-13.829-4.227-3.339-29.955a2.415,2.415,0,0,1,2.076-2.522",
    transform: "translate(-70.037 -47.497)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91088",
    "data-name": "Path 91088",
    d: "M232.42,160.358a.881.881,0,0,1-.818.917.842.842,0,0,1-.934-.763.881.881,0,0,1,.817-.918.843.843,0,0,1,.936.763",
    transform: "translate(-79.641 -55.101)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91089",
    "data-name": "Path 91089",
    d: "M232.819,154.586c-.105.119-.789-.352-1.736-.317s-1.625.532-1.732.42c-.052-.05.052-.261.347-.491a2.416,2.416,0,0,1,1.382-.479,2.326,2.326,0,0,1,1.387.4c.3.214.4.418.353.471",
    transform: "translate(-79.183 -53.074)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91090",
    "data-name": "Path 91090",
    d: "M226.035,163.006a6.264,6.264,0,0,1,1.529-.33c.241-.033.469-.089.5-.255a1.231,1.231,0,0,0-.186-.712l-.778-1.818a31.817,31.817,0,0,1-1.771-4.763,31.62,31.62,0,0,1,2.15,4.609c.261.639.511,1.247.748,1.829a1.4,1.4,0,0,1,.158.945.606.606,0,0,1-.386.367,1.679,1.679,0,0,1-.409.071,6.2,6.2,0,0,1-1.56.055",
    transform: "translate(-77.796 -53.56)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91091",
    "data-name": "Path 91091",
    d: "M222.358,183.145a17.473,17.473,0,0,1-9.276-2.138s2.61,4.674,9.458,3.8Z",
    transform: "translate(-73.57 -62.496)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91092",
    "data-name": "Path 91092",
    d: "M232.819,150.21c-.151.237-.882.107-1.727.206-.848.072-1.539.346-1.733.145-.086-.1,0-.328.285-.57a2.692,2.692,0,0,1,2.788-.283c.327.181.453.388.388.5",
    transform: "translate(-79.179 -51.598)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91093",
    "data-name": "Path 91093",
    d: "M217.147,161.085a.881.881,0,0,0,.911.826.842.842,0,0,0,.849-.857.88.88,0,0,0-.909-.826.843.843,0,0,0-.85.857",
    transform: "translate(-74.973 -55.321)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91094",
    "data-name": "Path 91094",
    d: "M215.113,155.669c.117.107.747-.433,1.693-.5s1.672.358,1.766.235c.047-.055-.079-.253-.4-.452a2.42,2.42,0,0,0-1.425-.33,2.318,2.318,0,0,0-1.337.54c-.275.244-.359.458-.3.505",
    transform: "translate(-74.265 -53.384)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91095",
    "data-name": "Path 91095",
    d: "M217.01,150.549c.2.2.916-.058,1.793-.117.875-.086,1.63.056,1.788-.179.069-.113-.06-.322-.4-.508a2.716,2.716,0,0,0-1.478-.272,2.681,2.681,0,0,0-1.408.511c-.3.238-.388.464-.3.565",
    transform: "translate(-74.915 -51.605)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91096",
    "data-name": "Path 91096",
    d: "M203.652,164.26c-.018-.511-.65-1.7-1.158-1.758-1.355-.164-3.781.027-3.687,3.451.128,4.681,4.8,3.586,4.806,3.452,0-.1.1-3.38.039-5.145",
    transform: "translate(-68.64 -56.092)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91097",
    "data-name": "Path 91097",
    d: "M202.976,168.569c-.021-.014-.08.06-.216.126a.818.818,0,0,1-.609.029,2.019,2.019,0,0,1-.983-1.785,2.7,2.7,0,0,1,.2-1.174.94.94,0,0,1,.6-.642.415.415,0,0,1,.487.21c.067.13.039.224.064.231s.1-.081.056-.273a.522.522,0,0,0-.193-.289.614.614,0,0,0-.454-.107,1.147,1.147,0,0,0-.832.749,2.769,2.769,0,0,0-.247,1.313,2.117,2.117,0,0,0,1.245,1.988.875.875,0,0,0,.742-.144c.142-.12.164-.225.147-.233",
    transform: "translate(-69.342 -56.931)",
    fill: "#ff9b6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91098",
    "data-name": "Path 91098",
    d: "M202.413,153.542l1.292,1.122c7.451-4.9,15.027-18.242,13.07-17.7a14.929,14.929,0,0,0-7.368-.142c-3.741.986-10.774,3.529-10.265,8a23.456,23.456,0,0,0,3.27,8.718",
    transform: "translate(-68.748 -47.102)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91099",
    "data-name": "Path 91099",
    d: "M224.976,170.749c-.02-.166-1.114.025-2.056-.775s-1.027-1.986-1.181-1.967c-.071,0-.167.3-.093.792a2.765,2.765,0,0,0,.924,1.653,2.41,2.41,0,0,0,1.711.579c.465-.039.714-.208.695-.282",
    transform: "matrix(0.819, -0.574, 0.574, 0.819, -131.369, 102.729)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91100",
    "data-name": "Path 91100",
    d: "M245,282.565a8.428,8.428,0,0,1-1.594-.869c-.956-.585-2.244-1.443-3.645-2.417l-3.583-2.5a11.164,11.164,0,0,1-1.463-1.07,8.426,8.426,0,0,1,1.594.868c.956.585,2.244,1.444,3.646,2.418l3.583,2.5a11.09,11.09,0,0,1,1.463,1.07",
    transform: "translate(-81.04 -95.193)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91101",
    "data-name": "Path 91101",
    d: "M187.764,195.219l13.053-3.909h13.711l13.169,3.909,1.2,3.469-22.48,11.281Z",
    transform: "translate(-64.828 -66.053)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91102",
    "data-name": "Path 91102",
    d: "M253.581,207.468s2.757,11.567,4.177,19.019c1.2,6.318,2.681,14.424-.488,17.651s-4.845,4.482-5.963,3.944-8.013-6.275-8.013-6.275l-1.5-34.477Z",
    transform: "translate(-83.484 -71.584)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91103",
    "data-name": "Path 91103",
    d: "M164.35,295.182c0-.35.454-20.109.454-20.109l3.453-1.4,22.973,6.295V302l-3.979.612Z",
    transform: "translate(-56.744 -94.49)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91104",
    "data-name": "Path 91104",
    d: "M188.581,302.215,188,281.636l-21.894-6.622,2.489-.691,22.353,6.268v21.151Z",
    transform: "translate(-57.352 -94.714)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91105",
    "data-name": "Path 91105",
    d: "M173.108,254.357a3.2,3.2,0,0,1-2.05-4.4c1.3-3.342,1.151-21.337,1.327-25.375.487-11.153.759-12.536,2.411-17.138l7.63,8.893s-.932,33.642,0,36.166,0,1.009-1.863,1.85-7.454,0-7.454,0",
    transform: "translate(-58.957 -71.625)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91106",
    "data-name": "Path 91106",
    d: "M175.537,279.279s.351,12.46.51,13.988-1.463,5.045-.255,6.421L177,301.064l2.383.382s-.08,1.376,1.192,1.376h1.271s.636,1.3,1.669.917.635-2.523.635-2.523,1.112.077,1.112-1.376,0-5.663-1.827-8.3-1.43-4.468-1.43-4.468l1.079-8.1-7.743.625",
    transform: "translate(-60.539 -96.321)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91107",
    "data-name": "Path 91107",
    d: "M184.022,197.28s-5.624,2.537-7.1,6.657l7.1,11.036v21.484s-1.2,6.6,2.771,6.67,7.1-4.573,7.1-4.573l22.827,2.66s1,2.873,4.222.953c.9-.538.73-1.789.73-8.255,0-1.673,9.764-17.021,9.959-17.345.09-.15.277-3.684.451-7.437a11.906,11.906,0,0,0-8.132-11.85s-19,15.71-39.932,0",
    transform: "translate(-61.087 -68.114)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91108",
    "data-name": "Path 91108",
    d: "M245.895,260.359c-.7.14-8.183,11.236-8.183,11.236l6.832,4.446,1.9-6.055,5.726-7.258s-.953-3.439-6.276-2.37",
    transform: "translate(-82.074 -89.822)",
    fill: "#ffc09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91109",
    "data-name": "Path 91109",
    d: "M178.551,214.973a1.205,1.205,0,0,1,.214.251c.128.174.329.422.553.766a24.552,24.552,0,0,1,1.736,3.01,36.09,36.09,0,0,1,3.2,10.977,73.724,73.724,0,0,1,.517,11.436c-.031,1.464-.078,2.647-.117,3.465-.022.376-.04.687-.055.941a1.257,1.257,0,0,1-.042.327,1.164,1.164,0,0,1-.027-.329c0-.255-.005-.566-.009-.943,0-.87.005-2.041.009-3.464a84.346,84.346,0,0,0-.614-11.386,38.19,38.19,0,0,0-3.076-10.92,29.945,29.945,0,0,0-1.631-3.042,11.475,11.475,0,0,1-.655-1.089",
    transform: "translate(-61.647 -74.223)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91110",
    "data-name": "Path 91110",
    d: "M246.3,220.363a6.393,6.393,0,0,1-.019,1.071c-.041.747-.1,1.728-.162,2.912-.142,2.458-.327,5.853-.477,9.606s-.235,7.154-.289,9.615c-.028,1.186-.052,2.168-.07,2.916a6.384,6.384,0,0,1-.067,1.069,6.436,6.436,0,0,1-.066-1.069c-.021-.689-.035-1.686-.038-2.918-.007-2.464.04-5.868.189-9.626s.374-7.154.578-9.609c.1-1.228.194-2.22.27-2.906a6.442,6.442,0,0,1,.151-1.061",
    transform: "translate(-84.63 -76.084)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91111",
    "data-name": "Path 91111",
    d: "M192.68,253.536A27.41,27.41,0,0,1,196.4,255.7a27.369,27.369,0,0,1,3.541,2.457,54.514,54.514,0,0,1-7.266-4.625",
    transform: "translate(-66.526 -87.536)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91112",
    "data-name": "Path 91112",
    d: "M201.157,246.924a18.893,18.893,0,0,0,1.421,8.968,4.087,4.087,0,0,1-.67-1.186,12.944,12.944,0,0,1-1.021-6.447,4.041,4.041,0,0,1,.271-1.335",
    transform: "translate(-69.337 -85.254)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91113",
    "data-name": "Path 91113",
    d: "M202.391,185.759l-7.812,3.546a41.362,41.362,0,0,0,.543,18.348,3.52,3.52,0,0,0,1.137,2.1,3.671,3.671,0,0,0,2.123.452l8.919.067-4.911-24.51",
    transform: "translate(-66.913 -64.136)",
    fill: "#263238"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndergraduateVisual);
export default __webpack_public_path__ + "static/media/undergraduate-visual.a1366bd11ab19db6078430eb7553d777.svg";
export { ForwardRef as ReactComponent };